export const es = {
  shell: {
    product: 'Accesibilidad, paso a paso',
    headline: 'Una web mejor empieza por saber qué mejorar.',
    intro: 'Analiza tus webs, encuentra barreras y organiza el trabajo de tu equipo en un mismo lugar.',
    connect: 'Conecta tu web',
    connectHint: 'Añade el dominio y elige su perfil normativo.',
    understand: 'Entiende las barreras',
    understandHint: 'Consulta problemas, prioridades y cómo corregirlos.',
    improve: 'Avanza con tu equipo',
    improveHint: 'Revisa los resultados y registra tus decisiones.',
    note: 'Las puntuaciones son orientativas. El análisis automático debe complementarse con una revisión manual para evaluar el cumplimiento de los requisitos de accesibilidad.',
  },
  app: {
    name: 'SiteNorma',
    home: 'SiteNorma, inicio del panel',
    website: 'SiteNorma, inicio de la web',
    skip: 'Saltar al contenido',
    language: 'Idioma',
    userMenu: 'Menú de usuario',
    signOut: 'Cerrar sesión',
    loading: 'Cargando…',
    retry: 'Volver a intentarlo',
    newTab: 'se abre en una pestaña nueva',
  },
  password: {
    show: 'Mostrar contraseña',
    hide: 'Ocultar contraseña',
    rules: {
      min: 'Al menos {{min}} caracteres',
      max: 'No más de {{max}} caracteres',
      met: 'cumplido',
      unmet: 'no cumplido',
    },
    errors: {
      min: 'La contraseña necesita al menos {{min}} caracteres.',
      max: 'La contraseña no puede tener más de {{max}} caracteres.',
    },
    nowVisible: 'La contraseña se ve en pantalla.',
    nowHidden: 'La contraseña está oculta.',
  },
  notFound: {
    title: 'Página no encontrada',
    text: 'Esta dirección no existe o ha cambiado.',
    home: 'Ir al panel',
  },
  form: {
    requiredNote: 'Los campos marcados con * son obligatorios.',
  },
  errors: {
    title: 'Algo ha fallado',
    generic: 'No hemos podido completar la solicitud. Inténtalo de nuevo.',
    required: 'Rellena este campo.',
    tooShort: 'Escribe al menos {{min}} caracteres.',
    invalidCredentials: 'El correo electrónico o la contraseña no son correctos.',
    userExists: 'Ya hay una cuenta con ese email. Entra o recupera tu contraseña.',
  },
  forms: {
    email: {
      required: 'Introduce tu correo electrónico.',
      invalid: 'Introduce un correo electrónico válido.',
    },
    password: {
      required: 'Introduce tu contraseña.',
    },
    privacy: {
      required: 'Debes marcar la casilla de privacidad para crear la cuenta.',
    },
    verifyLink: 'Este enlace no es válido o ha caducado. Solicita un nuevo correo de verificación.',
    limit: {
      before: 'Demasiados intentos. Podrás volver a intentarlo en',
      seconds_one: '{{count}} segundo.',
      seconds_other: '{{count}} segundos.',
      over: 'Ya puedes volver a intentarlo.',
      unknown: 'Demasiados intentos. Espera un momento y vuelve a intentarlo.',
    },
  },
  google: {
    or: 'o',
    login: 'Continuar con Google',
    signup: 'Registrarse con Google',
    connecting: 'Conectando con Google…',
    errors: {
      cancelled:
        'Has cancelado el acceso con Google. Puedes volver a intentarlo o usar tu correo y tu contraseña.',
      noAccount: 'No hay ninguna cuenta de SiteNorma con esa cuenta de Google. Créala primero.',
      notLinked:
        'Ya existe una cuenta con el correo de tu cuenta de Google, pero todavía no está verificada. Verifícala con el enlace que te enviamos o entra con tu contraseña.',
      notVerified:
        'Google no ha confirmado ese correo electrónico, así que no podemos usarlo para tu cuenta.',
      failed: 'No hemos podido continuar con Google. Inténtalo de nuevo o usa tu correo y tu contraseña.',
    },
  },
  login: {
    title: 'Inicia sesión',
    subtitle: 'Accede a tu cuenta con tu correo y tu contraseña.',
    email: 'Correo electrónico',
    password: 'Contraseña',
    submit: 'Iniciar sesión',
    forgot: '¿Has olvidado tu contraseña?',
    noAccount: '¿No tienes una cuenta?',
    signup: 'Crea tu cuenta',
    submitting: 'Iniciando sesión…',
  },
  signup: {
    title: 'Crea tu cuenta en SiteNorma',
    benefit: 'Gestiona tus análisis de accesibilidad y consulta sus resultados desde un mismo lugar.',
    privacy: {
      label:
        'He leído y acepto la <privacy>política de privacidad</privacy> y las <terms>condiciones de uso</terms>. Utilizaremos tu correo electrónico para gestionar tu cuenta y enviarte comunicaciones relacionadas con el servicio.',
      language: 'Estos documentos están en español.',
    },
    email: 'Correo electrónico',
    password: 'Contraseña',
    verify: 'Para activar tu cuenta, tendrás que verificar tu correo electrónico.',
    submit: 'Crear cuenta',
    submitting: 'Creando cuenta…',
    haveAccount: '¿Ya tienes una cuenta?',
    login: 'Inicia sesión',
  },
  verify: {
    title: 'Verifica tu correo electrónico',
    sent: 'Hemos enviado un correo de verificación a {{email}}. Abre el enlace para activar tu cuenta. El enlace caduca en una hora.',
    notSent:
      'Tu cuenta está creada, pero no hemos podido enviar el correo de verificación a {{email}}. Sigue pendiente de verificar: inténtalo de nuevo, no hace falta que te registres otra vez.',
    pendingLogin:
      'Para acceder, tienes que verificar tu correo electrónico. Hemos enviado un enlace a {{email}}; si ya no lo encuentras, puedes pedir otro.',
    spam: 'Si no encuentras el mensaje, revisa la carpeta de spam y comprueba que la dirección sea correcta.',
    resend: 'Reenviar correo de verificación',
    resending: 'Enviando…',
    resent: 'Hemos enviado otro correo de verificación a {{email}}.',
    wait: 'Podrás pedir otro correo en',
    over: 'Ya puedes reenviar el correo de verificación.',
    correct: 'Corregir correo electrónico',
    newEmail: 'Correo electrónico correcto',
    correctHint:
      'Enviaremos el enlace a la nueva dirección. Los enlaces enviados a la anterior dejarán de funcionar y tu cuenta seguirá pendiente hasta que verifiques la nueva.',
    correctSubmit: 'Guardar y enviar verificación',
    correctSubmitting: 'Guardando…',
    cancel: 'Cancelar',
    corrected:
      'Hemos enviado un correo de verificación a {{email}}. Los enlaces enviados a la dirección anterior ya no funcionan.',
    sendFailed:
      'No hemos podido enviar el correo de verificación. Tu cuenta sigue pendiente: inténtalo de nuevo.',
    credentials: 'No hemos podido comprobar la cuenta. Vuelve a iniciar sesión para continuar.',
    back: 'Volver a iniciar sesión',
    done: {
      okTitle: 'Correo verificado',
      ok: 'Tu correo electrónico se ha verificado. Ya puedes acceder a SiteNorma.',
      alreadyTitle: 'Cuenta ya verificada',
      already: 'Tu cuenta ya está verificada.',
      invalidTitle: 'Enlace no válido',
      invalid: 'Este enlace no es válido o ha caducado. Solicita un nuevo correo de verificación.',
      noneTitle: 'Verifica tu correo electrónico',
      none: 'Para verificar tu correo electrónico, abre el enlace del mensaje que te hemos enviado. Si no lo tienes, puedes solicitar uno nuevo.',
      login: 'Iniciar sesión',
      request: 'Solicitar un nuevo correo',
    },
    request: {
      title: 'Solicita un nuevo correo de verificación',
      intro: 'Introduce el correo electrónico con el que creaste tu cuenta.',
      email: 'Correo electrónico',
      submit: 'Solicitar nuevo correo',
      submitting: 'Solicitando…',
      sent: 'Si existe una cuenta pendiente de verificación asociada a este correo electrónico, recibirás un nuevo enlace. Revisa también la carpeta de spam.',
    },
  },
  forgot: {
    title: 'Recupera el acceso a tu cuenta',
    sentTitle: 'Revisa tu correo electrónico',
    intro:
      'Introduce el correo electrónico de tu cuenta para solicitar un enlace y restablecer tu contraseña.',
    email: 'Correo electrónico',
    submit: 'Solicitar enlace',
    sent: 'Si existe una cuenta asociada a este correo electrónico, recibirás un enlace para restablecer tu contraseña. Revisa también la carpeta de spam.',
    back: 'Volver a iniciar sesión',
    submitting: 'Solicitando enlace…',
  },
  reset: {
    title: 'Establece una nueva contraseña',
    doneTitle: 'Contraseña actualizada',
    password: 'Nueva contraseña',
    submit: 'Guardar contraseña',
    done: 'Tu contraseña se ha actualizado correctamente.',
    invalid:
      'Este enlace no es válido, ha caducado o ya se ha utilizado. Solicita uno nuevo para restablecer tu contraseña.',
    login: 'Iniciar sesión',
    submitting: 'Guardando…',
    another: 'Solicitar un nuevo enlace',
    pending:
      'Para acceder, todavía debes verificar tu correo electrónico. Al iniciar sesión te ayudaremos a hacerlo.',
  },
  organization: {
    title: 'Crea tu organización',
    intro: 'Tu organización agrupa tus webs y a las personas con las que trabajas en ellas.',
    name: 'Nombre de la organización',
    nameHint: 'Por ejemplo, el nombre de tu empresa o de tu agencia.',
    submit: 'Crear organización',
    nav: 'Organización',
    navMembers: 'Personas',
    navBilling: 'Plan y facturación',
  },
  billing: {
    title: 'Plan y facturación',
    loadFailed: 'No hemos podido cargar el plan. Inténtalo de nuevo.',
    myPlan: 'Mi plan',
    planName: 'Plan {{plan}}',
    includes: 'Incluye',
    pagesLimit: 'Páginas analizadas al mes',
    pagesPerMonth_one: '{{count}} página',
    pagesPerMonth_other: '{{count}} páginas',
    pagesUnlimited: 'Ilimitadas',
    wpLimit: 'Webs vinculadas con WordPress',
    wpSites_one: 'Hasta {{count}} web',
    wpSites_other: 'Hasta {{count}} webs',
    wpUnlimited: 'Ilimitadas',
    selectPages: 'Selección manual de páginas',
    selectPagesYes: 'Incluida',
    selectPagesNo: 'No incluida',
    seeOtherPlans: 'Ver otros planes',
    usageOfMonth: 'Uso de {{month}}',
    pagesAnalysed_one: '{{count}} página de la cuota este mes',
    pagesAnalysed_other: '{{count}} páginas de la cuota este mes',
    pagesUsedOf: '{{used}} de {{limit}} páginas de la cuota este mes',
    pagesAvailable_one: '{{count}} página disponible',
    pagesAvailable_other: '{{count}} páginas disponibles',
    monthlyQuotaUnlimited: 'Cuota mensual: ilimitada.',
    usageLabel: 'Páginas utilizadas de la cuota mensual',
    usageHint:
      'Suma las páginas de todos tus análisis de este mes: cada uno cuenta. En «Tus webs», «Páginas analizadas» solo suma el último análisis de cada web.',
    usageReserved_one: '{{count}} página reservada en análisis en cola o en curso.',
    usageReserved_other: '{{count}} páginas reservadas en análisis en cola o en curso.',
    quotaResets: 'El contador se reinicia el {{date}}.',
    managementTitle: 'Gestión y facturación',
    managementFree: 'Consulta otros planes o contacta con nuestro equipo para gestionar tu suscripción.',
    managementPaid: 'Consulta otros planes o contacta con nuestro equipo para gestionar tu suscripción.',
    readOnly:
      'Puedes consultar el plan y el uso. Para cambiarlo o gestionar la suscripción, pide a un propietario o administrador de la organización.',
    seePlans: 'Ver planes',
    contactSupport: 'Contactar con soporte',
    assigned:
      'Tu plan lo gestiona nuestro equipo y no cambia con una compra. Si necesitas cambiarlo, escríbenos.',
    purchase: {
      title: 'Elige tu plan',
      intro:
        'Pagas por las páginas que analizamos cada mes, con escritorio y móvil incluidos. Los precios son sin IVA.',
      period: 'Periodo de facturación',
      month: 'Mensual',
      year: 'Anual',
      yearHint: '2 meses gratis',
      perMonth: '{{price}} al mes',
      perYear: '{{price}} al año',
      equivalent: 'Equivale a {{price}} al mes',
      buy: 'Contratar {{plan}}',
      redirecting: 'Abriendo el pago seguro…',
      secure:
        'El pago se hace en una página segura de Stripe: SiteNorma no ve ni guarda los datos de tu tarjeta. Puedes cancelar cuando quieras y el plan sigue activo hasta el final del periodo pagado.',
      custom: '¿Necesitas más volumen? Habla con nosotros',
      errors: {
        failed: 'No hemos podido abrir el pago. Inténtalo de nuevo.',
        'suscripcion-activa': 'Ya tienes una suscripción. Para cambiar de plan, usa «Gestionar suscripción».',
        'plan-asignado': 'Tu plan lo gestiona nuestro equipo y no cambia con una compra.',
        limite: 'Has hecho demasiados intentos. Espera un poco e inténtalo de nuevo.',
        permisos: 'Solo los propietarios y administradores de la organización pueden contratar un plan.',
      },
    },
    subscription: {
      title: 'Tu suscripción',
      line: 'Plan {{plan}}, facturación {{period}}: {{price}} (sin IVA).',
      month: 'mensual',
      year: 'anual',
      renews: 'Se renueva el {{date}}.',
      cancels:
        'La suscripción está cancelada. Conservas el plan {{plan}} hasta el {{date}}; después vuelves al plan Gratis sin perder tus datos.',
      pastDue: 'No hemos podido cobrar el último pago. Actualiza tu método de pago para no perder el plan.',
      manage: 'Gestionar suscripción',
      manageHint:
        'Cambia de plan, actualiza tu tarjeta o tus datos de facturación, o cancela la suscripción. Se abre una página segura de Stripe.',
      portalFailed: 'No hemos podido abrir la gestión de la suscripción. Inténtalo de nuevo.',
    },
    return: {
      paid: 'Pago recibido. Tu plan {{plan}} ya está activo.',
      confirming: 'Estamos confirmando el pago con Stripe. Puede tardar unos segundos.',
      cancelled: 'No se ha realizado ningún cobro. Puedes elegir un plan cuando quieras.',
    },
    summaries: {
      gratis: 'Para una primera revisión de tus páginas clave.',
      pro: 'Para empresas que necesitan cumplir y documentarlo.',
      agencia: 'Para agencias que gestionan las webs de sus clientes.',
      'a-medida': 'Para grandes volúmenes y organizaciones con necesidades propias.',
      infinita: 'Acceso completo a SiteNorma sin límites de uso.',
    },
    features: {
      gratis: [
        'Análisis de una página y análisis rápido',
        'Accesibilidad automática según WCAG 2.2 A y AA, en escritorio y móvil',
      ],
      pro: [
        'Webs y usuarios ilimitados',
        'Análisis completos en webs verificadas',
        'Cumplimiento normativo y revisión manual guiada',
        'Informes PDF',
      ],
      agencia: ['Todo lo del plan Pro', 'Más capacidad para equipos que gestionan varias webs'],
      'a-medida': ['Todo lo del plan Agencia', 'Condiciones adaptadas a tu organización'],
      infinita: [],
    },
  },
  home: {
    figures: {
      sites: 'Webs',
      verified_one: '{{count}} verificada',
      verified_other: '{{count}} verificadas',
      problems: 'Tipos de problemas detectados',
      problemsHelp: 'Qué son los tipos de problemas',
      problemsHelpText:
        'Un tipo de problema es un fallo (por ejemplo, imágenes sin texto alternativo). Los elementos afectados son los lugares concretos donde aparece. Suma el último análisis de cada web, sin lo descartado.',
      elements_one: '{{count}} elemento afectado',
      elements_other: '{{count}} elementos afectados',
      elementsCapped_one: '{{count}}+ elemento afectado',
      elementsCapped_other: '{{count}}+ elementos afectados',
      problemsHelpCapped:
        'El «+» indica que el análisis ha dejado de contar elementos en alguna comprobación: el total real puede ser mayor.',
      global_one: '{{count}} global',
      global_other: '{{count}} globales',
      none: 'Sin análisis todavía',
      pages: 'Páginas analizadas',
      pagesHint: 'Solo el último análisis de cada web, no el uso del mes',
      pagesHintSome: 'Solo el último de {{analysed}} de {{total}} webs, no el uso del mes',
    },
    card: {
      pending: 'Pendiente de análisis',
      never: 'Prepara el primer análisis para ver los resultados.',
      requested: 'Solicitado el {{date}}',
      attempt: 'Último intento: {{date}}',
      lastAnalysis: 'Último análisis: {{date}}',
      lastCompleted: 'Último análisis completado: {{date}}',
      estimate: 'Estimación automática:',
      noEstimate: 'Sin estimación todavía',
      estimateHelp: 'Qué significa la estimación automática',
      estimateHelpText:
        'Es una estimación automática sobre 100. No es un porcentaje de cumplimiento ni equivale a la conformidad legal: las pruebas automáticas solo detectan una parte de las barreras.',
      estimateMethod: 'Cómo se calcula',
      deltaUp_one: 'Ha mejorado {{count}} punto respecto al análisis anterior.',
      deltaUp_other: 'Ha mejorado {{count}} puntos respecto al análisis anterior.',
      deltaDown_one: 'Ha empeorado {{count}} punto respecto al análisis anterior.',
      deltaDown_other: 'Ha empeorado {{count}} puntos respecto al análisis anterior.',
      problems_one: '{{count}} tipo de problema',
      problems_other: '{{count}} tipos de problemas',
      priority: {
        alta_one: '{{count}} de prioridad alta',
        alta_other: '{{count}} de prioridad alta',
        media_one: '{{count}} de prioridad media',
        media_other: '{{count}} de prioridad media',
        baja_one: '{{count}} de prioridad baja',
        baja_other: '{{count}} de prioridad baja',
      },
      notAnalysed_one: '{{count}} página no se ha podido analizar.',
      notAnalysed_other: '{{count}} páginas no se han podido analizar.',
      ownership: {
        verified: 'Propiedad verificada',
        unverified: 'Propiedad sin verificar',
        checking: 'Comprobando la propiedad',
        failed: 'No se ha podido verificar la propiedad',
      },
      actions: {
        prepare: 'Analizar mi web',
        results: 'Ver resultados',
        progress: 'Ver el análisis',
        retry: 'Reintentar análisis',
        open: 'Abrir la web',
      },
    },
    subtitle: 'Un lugar para revisar y mejorar la accesibilidad de tus webs.',
    listTitle: 'Todas las webs',
    search: 'Buscar por nombre o dominio',
    results: 'Webs encontradas: {{count}}',
    noResults: 'No hay webs que coincidan. Prueba con otro nombre o dominio.',

    title: 'Tus webs',
    organization: 'Organización: {{name}} · Tu rol: {{role}}',
    empty: 'Todavía no has añadido ninguna web.',
    emptyHint:
      'Añade tu primera web y empieza con un escaneo rápido. Verifica su propiedad para acceder a los escaneos completos.',
    emptyReadOnly: 'Cuando alguien de tu organización añada una web, la verás aquí.',
    add: 'Añadir una web',
    roles: { owner: 'Propietario', admin: 'Administrador', editor: 'Editor', viewer: 'Lector' },
  },
  sites: {
    status: {
      verified: 'Propiedad verificada',
      unverified: 'Propiedad sin verificar',
      checking: 'Comprobando la propiedad',
      failed: 'No se ha podido verificar la propiedad',
    },
    profiles: {
      eaa: 'Servicio privado (Acta Europea de Accesibilidad)',
      'sector-publico': 'Sector público',
      voluntario: 'Voluntario',
      'sin-definir': 'Sin definir',
    },
    profileHints: {
      eaa: 'Para empresas que ofrecen a consumidores servicios incluidos en la ley (comercio electrónico, banca, transporte…). Si te afecta depende de tu actividad y de tu tamaño. Referencia: Ley 11/2023.',
      'sector-publico':
        'Para administraciones y organismos del sector público. Referencia: Real Decreto 1112/2018.',
      voluntario:
        'Para webs sin una obligación legal específica: se toma WCAG 2.2 AA como referencia técnica.',
    },
    standards: {
      'EN301549-4.1.1': 'EN 301 549 v4.1.1 · WCAG 2.2 AA',
      'EN301549-3.2.1': 'EN 301 549 v3.2.1 · WCAG 2.1 AA',
      'WCAG22-AA': 'WCAG 2.2 AA',
      'WCAG21-AA': 'WCAG 2.1 AA',
    },
  },
  newSite: {
    title: 'Añade tu web',
    intro: 'Introduce la dirección de tu web. Después podrás iniciar el análisis de accesibilidad.',
    url: 'Dirección de la web',
    urlHint:
      'Introduce la dirección de la página que quieres analizar primero. Por ejemplo, https://www.tuweb.com',
    name: 'Nombre de la web (opcional)',
    nameHint: 'Si lo dejas vacío, usaremos el dominio de la web.',
    normalized: 'Dirección que se guardará: {{url}}',
    existing: 'Ya tienes una web con esta dirección: «{{name}}».',
    open: 'Abrir web',
    submit: 'Añadir web',
    submitting: 'Añadiendo web…',
    cancel: 'Volver a tus webs',
    errors: {
      url: 'Introduce una dirección web válida, por ejemplo, https://www.tuweb.com',
      duplicada: 'Esta web ya existe en tu organización.',
      permiso: 'Tu rol no permite añadir webs.',
    },
  },
  account: {
    menuProfile: 'Mi perfil',
    menuSecurity: 'Seguridad',
    planLabel: 'Plan {{plan}}',
    nav: 'Tu cuenta',
    scope:
      'Estos ajustes son personales: no dependen de ninguna web ni de tu organización. Los ajustes de cada web están en la propia web, en «Ajustes». El plan y la facturación están en Organización → Plan y facturación.',
    profile: {
      title: 'Mi perfil',
      name: 'Nombre',
      email: 'Correo electrónico',
      emailHint: 'Es el correo con el que accedes a SiteNorma. No se puede cambiar desde aquí.',
      save: 'Guardar cambios',
      saving: 'Guardando…',
      saved: 'Cambios guardados.',
    },
    security: {
      title: 'Seguridad',
      intro:
        'Cambia la contraseña con la que accedes a SiteNorma. Al hacerlo se cerrarán las sesiones abiertas en otros dispositivos; esta sesión continúa.',
      current: 'Contraseña actual',
      new: 'Nueva contraseña',
      submit: 'Cambiar contraseña',
      submitting: 'Cambiando…',
      done: 'Tu contraseña se ha cambiado. Se han cerrado las demás sesiones.',
      currentWrong: 'La contraseña actual no es correcta.',
    },
  },
  seal: {
    tab: 'Sello de accesibilidad',
    title: 'Sello de accesibilidad',
    intro:
      'Muestra en tu web que has superado las comprobaciones de accesibilidad de SiteNorma. El sello permite consultar los resultados y la fecha de la última revisión, pero no constituye una certificación WCAG.', // claims-ok
    status: {
      inactivo: 'Sin activar',
      vigente: 'Activo',
      caducado: 'Caducado',
      suspendido: 'Suspendido',
    },
    statusHint: {
      inactivo: 'El sello no se muestra en ninguna web.',
      vigente: 'Cumples los requisitos y la última revisión es reciente.',
      caducado:
        'La última revisión completa tiene más de {{days}} días: haz un análisis completo nuevo para renovarlo. Mientras tanto el sello se muestra como caducado.',
      suspendido:
        'Ya no se cumple algún requisito: el sello se muestra como suspendido y la ficha pública lo indica.',
    },
    requirements: {
      title: 'Comprobar los requisitos',
      progress: '{{done}} de {{total}} requisitos completados',
      recommended: 'Recomendado (no es un requisito)',
      met: 'cumplido',
      pending: 'pendiente',
      lastAnalysis: 'Último análisis completo: {{date}} ({{pages}} páginas analizadas).',
    },
    criteria: {
      ownership: 'La propiedad de la web está verificada.',
      analysis: 'Hay un análisis completo vigente, de los últimos {{days}} días.',
      noHigh: 'No hay problemas de prioridad alta pendientes.',
      manual:
        'Todas las comprobaciones manuales aplicables están revisadas, sin problemas de prioridad alta.',
    },
    recommended: {
      statement:
        'La web tiene una declaración de accesibilidad publicada. Es un documento aparte del sello, pero lo recomendamos.',
    },
    fix: {
      ownership: 'Verificar la web',
      analysis: 'Hacer un análisis completo',
      noHigh: 'Ver los problemas',
      manual: 'Hacer las revisiones manuales',
      statement: 'Crear la declaración',
    },
    scope: {
      title: 'Qué se comprueba',
      hint: 'Páginas y comprobaciones que hay que superar',
      analysis:
        'Un análisis completo de la web (hasta 50 páginas, en escritorio y móvil), terminado con todas las páginas analizadas, de los últimos {{days}} días.',
      checks:
        'Ese análisis no deja problemas de prioridad alta pendientes; lo que el equipo descartó con justificación no cuenta.',
      manual:
        'Todas las comprobaciones manuales que se aplican a la web, con una revisión registrada y sin hallazgos de prioridad alta.',
      not: 'Superarlas no equivale a acreditar el cumplimiento completo de las WCAG: el sello indica exactamente esto y nada más.',
    },
    activate: {
      title: 'Activar el sello',
      intro:
        'Al activarlo se crea la ficha pública de verificación y el sello queda listo para ponerlo en tu web. No aparece en tu web hasta que lo incorpores (paso siguiente).',
      button: 'Activar el sello',
      disabled_one: 'Falta {{count}} requisito',
      disabled_other: 'Faltan {{count}} requisitos',
      done: 'Sello activado. Ahora ponlo en el pie de tu web.',
      active: 'El sello está activado.',
    },
    withdraw: 'Retirar el sello',
    withdrawTitle: '¿Retirar el sello?',
    withdrawMessage: 'El sello dejará de mostrarse en tu web y la ficha pública dejará de funcionar.',
    withdrawn: 'Sello retirado.',
    notEligible: 'La web ya no cumple todos los requisitos.',
    readOnly:
      'Tu rol solo permite consultar el sello. Pide a alguien con rol de editor o superior que lo active.',
    preview: {
      title: 'Vista previa',
      notReady_one: 'Todavía no se puede activar: falta {{count}} requisito. Así se vería cuando se cumpla.',
      notReady_other:
        'Todavía no se puede activar: faltan {{count}} requisitos. Así se vería cuando se cumplan.',
      language: 'Idioma',
      detected: '(detectado en tu web)',
      theme: 'Fondo del pie de página',
      themes: {
        light: 'Claro',
        dark: 'Oscuro',
      },
      size: 'Tamaño',
      sizes: {
        s: 'Pequeño',
        m: 'Mediano',
        l: 'Grande',
      },
      states: {
        vigente: 'Activo',
        caducado: 'Caducado',
        suspendido: 'Suspendido',
      },
      footer: 'Así queda en un pie de página',
      footerLinks: 'Aviso legal · Privacidad · Cookies',
      alt: 'Sello de accesibilidad de SiteNorma (vista previa)',
    },
    embed: {
      title: 'Incorporarlo al pie de tu web',
      locked: 'Disponible cuando actives el sello.',
      wordpress: {
        title: 'WordPress',
        how: 'En tu WordPress, abre SiteNorma → Conexión y activa «Mostrar sello en mi web». Elige el tamaño, el idioma y la versión clara u oscura: el plugin lo pone en el pie de página y solo lo muestra mientras el sello está activo.',
        open: 'Abrir el plugin en tu WordPress',
        none: 'Con el plugin de SiteNorma el sello se pone solo en el pie de WordPress, sin tocar código.',
        connect: 'Conectar el plugin',
      },
      html: {
        title: 'Copiar código HTML',
        hint: 'Para Shopify, webs a medida y otros gestores: el código muestra el sello como una imagen SVG servida por SiteNorma, que enlaza a la ficha pública de verificación.',
        steps: {
          one: 'Elige arriba el idioma, el fondo y el tamaño.',
          two: 'Copia el código.',
          three:
            'Pégalo en el HTML del pie de página de tu web o de tu plantilla. No necesita scripts ni cambia los estilos de tu web.',
        },
        label: 'Código HTML',
        snippetHint:
          'Para {{language}}, fondo {{theme}} y tamaño {{size}}. La imagen se actualiza sola si el sello caduca o se suspende.',
      },
    },
    verify: {
      title: 'Verificar y mantener la vigencia',
      intro:
        'Quien pulse el sello llega a una ficha pública de SiteNorma con el nombre y el dominio de la web, su estado, las fechas de la última revisión y de caducidad y el alcance de lo comprobado.',
      open: 'Abrir la ficha pública',
      locked: 'La ficha se crea al activar el sello.',
      renews: 'Se renueva sola cuando un análisis completo nuevo supera los requisitos.',
      expires: 'Caduca a los {{days}} días del último análisis completo si no hay uno nuevo.',
      suspends: 'Se suspende si un análisis detecta que ya no se cumplen los requisitos.',
      live: 'La ficha y la imagen del sello reflejan el cambio al momento: una web con el sello caducado o suspendido no lo muestra como válido.',
      lastReview: 'Última revisión: {{date}}.',
      validUntil: 'Vigente hasta el {{date}} si no hay un análisis completo más reciente.',
    },
  },
  statement: {
    tab: 'Declaración de accesibilidad',
    title: 'Declaración de accesibilidad',
    intro:
      'Genera la declaración de accesibilidad de esta web en cuatro pasos: elige los idiomas, completa los datos una sola vez, revisa el documento y apruébalo. Con varios idiomas, un solo formulario genera todos; en tu web el script muestra el de la página. Es un documento informativo sobre el estado de accesibilidad, aunque tenga problemas pendientes. Aprobarlo no lo publica en la web.',
    language: 'Idiomas de la declaración',
    languages: {
      es: 'Español',
      ca: 'Català',
      en: 'English',
      fr: 'Français',
      de: 'Deutsch',
      prompt: 'Elige uno o varios idiomas. Los detectados en tu web aparecen marcados.',
      noneDetected:
        'Todavía no hemos detectado los idiomas de tu web. Elige en cuáles quieres la declaración.',
      helpLabel: 'Ayuda sobre los idiomas de la declaración',
      help: 'Marca todos los idiomas en los que quieres la declaración. Los datos del siguiente paso se rellenan una sola vez y generan el texto en cada idioma. En tu web, un solo script muestra el de la página.',
      detected: 'detectado',
      needOne: 'Elige al menos un idioma para continuar.',
      selectedOne:
        'La declaración se preparará en {{name}}. Marca otro idioma si quieres quitar este; tiene que quedar al menos uno.',
      selectedMany:
        'La declaración se preparará en {{count}} idiomas ({{list}}). Los datos se rellenan una sola vez para todos.',
      removeApproved:
        'Al continuar se eliminará la declaración aprobada de los idiomas que has quitado (incluido su historial).',
      next: 'Siguiente',
      unsupported:
        'También hay páginas en estos idiomas, para los que todavía no tenemos plantilla: {{list}}.',
      updated: 'Idiomas actualizados.',
    },
    published: 'versión {{n}} validada',
    draft: 'borrador',
    none: 'sin crear',
    cancel: 'Cancelar',
    readOnly:
      'Tu rol solo permite consultar la declaración. Pide a alguien con rol de editor o superior que la edite y la valide.',
    errors: {
      incomplete: 'La declaración todavía no está completa: revisa lo que falta en el paso 4.',
      permission: 'Tu rol no permite cambiar la declaración. No se ha guardado nada.',
      generic: 'No hemos podido completar la acción. Inténtalo de nuevo; no se ha publicado nada.',
      noWordpress: 'Esta web no tiene el plugin de SiteNorma conectado en WordPress.',
    },
    steps: {
      language: 'Idiomas',
      data: 'Completar los datos',
      review: 'Generar y revisar',
      validate: 'Revisar y aprobar',
    },
    status: {
      pendiente: 'Pendiente de validación',
      validada: 'Validada, todavía no publicada en tu web',
      publicada: 'Publicada en tu web',
      last: 'versión {{n}}, aprobada el {{date}}',
      changes: 'hay cambios sin aprobar',
    },
    data: {
      title: 'Completar los datos',
      intro:
        'Solo pedimos lo imprescindible: los datos de quien responde de la web. El resto lo tomamos de tu web, del perfil normativo y de los análisis. Estos datos son los mismos para todos los idiomas elegidos: no hace falta repetirlos.',
      entity: 'Entidad responsable',
      name: 'Nombre de la entidad',
      address: 'Dirección',
      email: 'Correo electrónico',
      emailHint:
        'Es también el correo de contacto de accesibilidad, salvo que indiques otro en las opciones avanzadas.',
      website: 'Web',
      prefilled: 'Rellenados con los datos de tu web. Puedes cambiarlos si hace falta.',
      siteName: 'Nombre de la web',
      siteUrl: 'Dirección de la web',
      guidedTitle: 'Procedimiento de reclamación',
      advanced: 'Opciones avanzadas',
      advancedHint: 'Identificación fiscal, teléfono, contacto, alcance, excepciones y cómo se ha evaluado',
      taxId: 'Identificación fiscal (opcional)',
      phone: 'Teléfono (opcional)',
      contactEmail: 'Correo de contacto de accesibilidad (opcional)',
      contactEmailHint: 'Si lo dejas vacío se usa el correo de la entidad.',
      contactUrl: 'Formulario o página de contacto (opcional)',
      responseDays: 'Plazo de respuesta en días (opcional)',
      scope: 'Alcance (opcional)',
      scopeHint: 'Si la declaración no cubre toda la web (una sección, un subdominio…), dilo aquí.',
      exceptions: 'Excepciones (opcional)',
      exceptionsHint:
        'Contenido fuera del alcance o cargas desproporcionadas, con tus propias palabras y su justificación.',
      enforcement: 'Procedimiento de reclamación',
      enforcementHint:
        'Opcional. Indica ante quién y cómo se puede reclamar, si tu entidad tiene un procedimiento. SiteNorma no lo inventa.',
      enforcementRequired:
        'Obligatorio en el sector público. Indica la unidad responsable y el procedimiento de reclamación que te corresponde: SiteNorma no lo inventa.',
      preparationNote: 'Cómo se ha evaluado, en tus palabras (opcional)',
      generate: 'Generar la declaración',
      regenerate: 'Volver a generar la declaración',
      generated: 'Declaración generada en todos los idiomas elegidos. Revísala.',
    },
    evaluation: {
      label: 'Evaluación',
      state: {
        pendiente: 'Pendiente',
        incompleta: 'Incompleta',
        completada: 'Completada',
      },
      pendingText: 'Haz el análisis y la revisión manual para preparar la declaración.',
      incompleteBarriers: 'Hay barreras detectadas. Completa la revisión manual para fijar la conformidad.',
      incompleteClear:
        'El análisis automático no ha detectado barreras. Completa la revisión manual para fijar la conformidad.',
      pendingChecks: 'Ver comprobaciones pendientes',
      completePartial:
        'La revisión justifica conformidad parcial. Los incumplimientos están en la declaración.',
      completeUndeclared: 'La revisión no permite declarar un grado de conformidad.',
    },
    document: {
      label: 'Documento',
      draft: 'Borrador',
      approved: 'Aprobado',
    },
    evidence: {
      auto: 'Análisis automático',
      autoValue:
        'Último análisis el {{date}}: {{pages}} páginas analizadas y {{problems}} problemas pendientes.',
      noScan:
        'Todavía no hay ningún análisis terminado. Haz uno en «Análisis» para que la declaración lo recoja.',
      manual: 'Revisión manual',
      manualValue:
        '{{registered}} de {{total}} criterios revisados. Los demás no se han comprobado y la declaración lo dice.',
      outdated: 'Hay un análisis más reciente que el usado para este texto.',
    },
    review: {
      title: 'Generar y revisar',
      intro:
        'SiteNorma ha generado la declaración con tus datos, el perfil normativo de la web y la referencia técnica ({{standard}}). Así se verá en tu web.',
      generated: 'Declaración actualizada con el último análisis.',
      update: 'Actualizar con el último análisis',
      previewLabel: 'Vista previa de la declaración',
      empty: 'Todavía no hay declaración: completa los datos para generarla.',
      readOnly:
        'El texto es de solo lectura. Si necesitas cambiar algo, vuelve a los datos: la declaración se genera de nuevo.',
      edit: 'Modificar datos',
      continue: 'Revisar y aprobar',
    },
    validate: {
      title: 'Revisar y aprobar',
      blocked: 'Falta información obligatoria para aprobar.',
      fixData: 'Completar los datos',
      regime: 'El sector público exige una situación de conformidad concreta.',
      openAnalysis: 'Ir al análisis',
      seeText: 'Ver la declaración',
      confirm: 'He revisado el documento y confirmo que la información es correcta.',
      confirmPending: 'He revisado el documento en los idiomas pendientes y confirmo que la información es correcta.',
      action: 'Aprobar el documento',
      actionPending: 'Aprobar los idiomas pendientes',
      clarification: 'Aprobar no certifica la accesibilidad de la web.',
      back: 'Volver a la revisión',
      done: 'Versión {{n}} aprobada en todos los idiomas listos. Ahora elige cómo publicarla.',
      donePending: 'Aprobados: {{list}}. Ya puedes copiar el HTML de cada idioma.',
      pendingLangs_one:
        'Queda por aprobar {{list}}. Sin aprobarlo, el script y el HTML solo incluyen los idiomas ya aprobados.',
      pendingLangs_other:
        'Quedan por aprobar {{list}}. Sin aprobarlos, el script y el HTML solo incluyen los idiomas ya aprobados.',
      unvalidatedChanges:
        'Hay cambios tras la versión {{n}}: en tu web sigue esa versión hasta que apruebes la nueva.',
    },
    problems: {
      entity: 'Falta el nombre de la entidad.',
      address: 'Falta la dirección de la entidad.',
      email: 'Falta el correo de la entidad.',
      site: 'Falta la dirección de la web.',
      contact: 'Falta un correo de contacto de accesibilidad.',
      enforcement: 'Falta el procedimiento de reclamación (obligatorio en el sector público).',
      conformity:
        'El sector público exige una situación de conformidad concreta y la evaluación no la justifica.',
      blank: 'El texto todavía tiene datos por completar: vuelve a los datos.',
      empty: 'Todavía no hay declaración: completa los datos para generarla.',
    },
    publication: {
      title: 'Publicar en tu web',
      intro:
        'La versión {{n}} está aprobada ({{date}}). Aprobar no la pone en tu web: elige un método, sigue los pasos y márcalo cuando esté en la página. El script y el enlace muestran siempre la última versión aprobada.',
      choose: 'Elige cómo añadir la declaración',
      languageScript:
        'Un solo script sirve para {{list}}. Muestra el idioma de la página (atributo lang o la ruta) en cuanto carga, sin una segunda petición.',
      languageLink: 'Este enlace es de la declaración en {{name}}. Cada idioma tiene el suyo.',
      languageHtml:
        'Copia el HTML de cada idioma y pégalo en la página correspondiente. Elige el idioma y pulsa copiar.',
      mark: {
        script: 'Ya he añadido el script',
        link: 'Ya he enlazado la página',
        html: 'Ya he pegado el HTML',
        wordpress: 'Ya he pedido publicarlo en WordPress',
      },
      markedOn: 'Marcada como publicada el {{date}}.',
      saved: {
        script: 'Marcada como publicada con el script.',
        link: 'Marcada como publicada con el enlace.',
        html: 'Marcada como publicada con el HTML.',
        wordpress: 'Pedido de publicación en WordPress registrado.',
      },
    },
    delivery: {
      recommended: 'Recomendado',
      script: 'Fragmento de código',
      scriptSummary: 'Se actualiza sola al aprobar una versión nueva y sigue el idioma de la página.',
      scriptHint: 'Copia el código. Verás un aviso de carga hasta que el texto esté listo.',
      link: 'Enlace alojado',
      linkSummary: 'Página alojada por SiteNorma que se actualiza sola al aprobar.',
      linkHint: 'Copia este enlace y úsalo en tu web, por ejemplo en el pie de página.',
      html: 'HTML',
      htmlSummary: 'Copia el HTML a mano. Tendrás que pegarlo de nuevo si apruebas una versión nueva.',
      htmlHint: 'Copia este HTML e insértalo en la página de tu web.',
      htmlLangs: 'Idioma del HTML',
      htmlNote:
        'Este HTML no se actualiza solo: si apruebas otra versión, vuelve a copiarlo. Para que se actualice sola, usa el fragmento de código o el enlace.',
      wordpress: 'WordPress',
      wordpressSummary: 'El plugin de SiteNorma crea o actualiza la página en tu WordPress.',
      wordpressHint:
        'Marca esta opción y publica desde el plugin de SiteNorma en WordPress (o espera a la sincronización horaria).',
      wordpressNote: 'El plugin confirma cuándo la página está publicada en tu web.',
      wordpressConnect: 'Conecta el plugin de SiteNorma en WordPress para publicar la declaración desde allí.',
      wordpressGo: 'Ir a Integraciones → WordPress',
      stepCopy: 'Paso 1: copia este código',
      stepPaste: 'Paso 2: pégalo en la página de tu web donde quieras que aparezca la declaración.',
      stepCopyLink: 'Paso 1: copia este enlace',
      stepPasteLink: 'Paso 2: enlázalo desde tu web, por ejemplo en el pie de página.',
      stepCopyHtml: 'Paso 1: copia el HTML en {{name}}',
      quality:
        'Mientras llega el script se muestra «Cargando…» en el idioma de la página. El texto de todos los idiomas aprobados va dentro del propio script, se carga de forma asíncrona y no añade dependencias; usa encabezados y listas reales y hereda la tipografía y los colores de tu web. Si no se pudiera mostrar, queda un enlace a la declaración.',
      copy: 'Copiar',
      copied: 'Copiado',
    },
    versions: {
      title: 'Versiones',
      hint: 'Cada versión validada se conserva con su fecha y quien la validó. Puedes recuperar una como borrador para actualizarla.',
      version: 'Versión {{n}}',
      by: 'validada por {{name}}',
      view: 'Ver',
      hide: 'Ocultar',
      restore: 'Recuperar como borrador',
      restored: 'La versión {{n}} es ahora el borrador. No se publica nada hasta que la valides.',
      modify: 'Modificar datos y crear una nueva versión',
    },
  },
  pagesList: {
    title: 'Páginas analizadas',
    intro: 'Inventario de la web (no solo el último análisis): cada página muestra su último resultado.',
    figures: {
      analysed: 'Páginas analizadas',
      pending: 'Con problemas pendientes',
      clean: 'Sin problemas pendientes',
    },
    empty: 'Todavía no hay páginas analizadas. Empieza con un análisis desde «Análisis».',
    notFound: 'Esta página ya no está en los resultados de esta web.',
    noMatch: 'Ninguna página coincide con lo que has elegido. Cambia el filtro o la búsqueda.',
    filter: {
      label: 'Mostrar',
      todas: 'Todas las páginas',
      pendientes: 'Con problemas pendientes',
      limpias: 'Sin problemas pendientes',
    },
    pending_one: '{{count}} problema pendiente',
    pending_other: '{{count}} problemas pendientes',
    none: 'Sin problemas pendientes',
    verified_one: '{{count}} corrección verificada',
    verified_other: '{{count}} correcciones verificadas',
    lastAnalysis: 'Último análisis: {{date}}',
  },
  nav: {
    label: 'Panel',
    sites: 'Webs',
    organization: 'Organización',
    users: 'Usuarios',
    menu: 'Menú',
    integrations: 'Integraciones',
  },
  mcp: {
    title: 'MCP para Cursor y otros agentes',
    intro:
      'El agente lee tus análisis y aplica las correcciones en el código local de tu web. No escribe en la web publicada: tú publicas los cambios.',
    note: 'El token es personal y actúa con tus permisos. No lo compartas ni lo subas al repositorio. Si lo pierdes, revócalo y crea uno nuevo.',
    create: {
      title: 'Crear un token',
      name: 'Nombre (opcional)',
      namePlaceholder: 'p. ej. Cursor del portátil',
      button: 'Crear token',
      working: 'Creando…',
      limit: 'Has llegado al máximo de {{max}} tokens activos. Revoca uno para crear otro.',
    },
    created: {
      title: 'Enlace para el agente',
      body: 'Cópialo y pégalo en el chat del agente (Cursor u otro). El agente lee las instrucciones del enlace y configura el MCP de SiteNorma. El enlace lleva el token, se muestra solo una vez y no debe compartirse ni pegarse en otro sitio.',
      copyLink: 'Copiar enlace',
      linkCopied: 'Enlace copiado.',
      copy: 'Copiar token',
      copied: 'Token copiado.',
      configTitle: 'Configuración para otros agentes',
      configHint:
        'El enlace hace que el agente escriba esta configuración. La orden es la ruta del lanzador en este equipo. Si ese archivo no está, el agente lo dirá.',
      copyConfig: 'Copiar configuración',
      configCopied: 'Configuración copiada.',
      close: 'He guardado el token',
    },
    steps: {
      title: 'Cómo usarlo',
      one: 'Crea un token en esta página.',
      two: 'Copia el enlace y pégalo en el chat del agente. Con eso configura el MCP de SiteNorma.',
      three:
        'Abre en el editor el código de tu web (tema o repositorio) y pide al agente que corrija los problemas de SiteNorma.',
      four: 'Publica los cambios y, en el panel, lanza «Comprobar la corrección» o un análisis nuevo.',
    },
    list: {
      title: 'Tokens activos',
      empty: 'Todavía no hay ningún token MCP.',
      tableLabel: 'Tokens MCP (la tabla se desplaza)',
      name: 'Nombre',
      prefix: 'Token',
      owner: 'Creado por',
      created: 'Creado',
      lastSeen: 'Último uso',
      never: 'Todavía ninguno',
      actions: 'Acciones',
      revoke: 'Revocar',
      revokeTitle: '¿Revocar «{{name}}»?',
      revokeBody:
        'El agente que use este token dejará de poder leer tus análisis. Podrás crear otro cuando quieras.',
      revokeConfirm: 'Revocar',
      cancel: 'Cancelar',
      revoked: 'El token «{{name}}» se ha revocado.',
      usage: '{{mine}} de {{max}} tokens tuyos activos en esta organización.',
    },
    errors: {
      limit: 'Has llegado al máximo de tokens activos.',
      generic: 'No se ha podido completar la acción. Inténtalo de nuevo.',
    },
  },
  integrations: {
    title: 'Integraciones',
    intro:
      'Conecta SiteNorma con otras plataformas y con tu entorno de desarrollo para consultar resultados y corregir problemas de accesibilidad.',
    nav: 'Secciones de integraciones',
    mcp: 'MCP',
    wordpress: 'WordPress',
  },
  wordpress: {
    title: 'Plugin de WordPress',
    intro:
      'Instala el plugin de SiteNorma en tu WordPress y verás los resultados de esa web sin salir de su escritorio. El plugin solo muestra los datos de la web donde está instalado: los análisis completos y los informes en PDF se hacen siempre aquí, en la plataforma.',
    note: 'Los resultados son una estimación automática: las pruebas automáticas solo detectan problemas y el resto requiere revisión manual. El plugin muestra la misma información que ves aquí.',
    download: {
      eyebrow: 'Descarga',
      title: 'SiteNorma para WordPress',
      meta: 'Versión {{version}} · {{size}} · requiere WordPress {{wp}} y PHP {{php}}',
      button: 'Descargar el plugin',
      checksum: 'Comprobar la integridad del archivo',
      unavailable: 'El plugin todavía no está disponible para descargar.',
    },
    steps: {
      title: 'Cómo instalarlo',
      one: 'Descarga el archivo ZIP.',
      two: 'En tu WordPress, entra en Plugins → Añadir nuevo → Subir plugin y elige el ZIP.',
      three: 'Activa el plugin y pulsa «Conectar con SiteNorma». Te traerá aquí para aprobar la conexión.',
      four: 'Tu web aparece en la plataforma, se verifica sola y el plugin muestra sus resultados.',
    },
    usage: {
      label: 'Webs vinculadas con el plugin',
      of: '{{used}} de {{limit}} webs vinculadas con tu tarifa ({{plan}})',
      unlimited: '{{used}} webs vinculadas (tu tarifa no tiene límite)',
    },
    list: {
      title: 'Webs vinculadas',
      empty: 'Todavía no hay ninguna web vinculada con el plugin.',
      tableLabel: 'Webs vinculadas con el plugin (la tabla se desplaza)',
      site: 'Web',
      status: 'Propiedad',
      verified: 'Verificada',
      unverified: 'Sin verificar',
      versions: 'Versiones',
      versionsValue: 'WordPress {{wp}} · plugin {{plugin}}',
      lastSeen: 'Última conexión',
      never: 'Todavía ninguna',
      linkedBy: 'Vinculada por',
      actions: 'Acciones',
      unlink: 'Desvincular',
      unlinkTitle: '¿Desvincular {{name}}?',
      unlinkBody:
        'El plugin de esa web dejará de mostrar resultados en cuanto lo intente de nuevo. La web y su historial se quedan en SiteNorma; podrás volver a vincularla cuando quieras.',
      unlinkConfirm: 'Desvincular',
      cancel: 'Cancelar',
      unlinked: '{{name}} se ha desvinculado.',
    },
    tab: {
      name: 'WordPress',
      title: 'Plugin de WordPress',
      none: 'Ninguna instalación de WordPress está vinculada a esta web.',
      link: 'Gestionar en Integraciones',
      open: 'Abrir en WordPress',
    },
    connect: {
      title: 'Conectar WordPress con SiteNorma',
      intro: 'Un WordPress quiere vincularse a tu cuenta. Revisa de qué web se trata antes de aprobar.',
      site: 'Web que se vincula',
      organization: 'Organización',
      account: 'Cuenta',
      scopeTitle: 'Qué podrá hacer el plugin',
      can1: 'Registrar esta web en tu organización y verificar que es tuya.',
      can2: 'Mostrar en WordPress los resultados de esta web, y solo de esta.',
      can3: 'Pedir un análisis rápido de esta web, dentro de los límites de tu tarifa.',
      cannot:
        'No podrá ver otras webs, cambiar tu cuenta ni generar informes en PDF: eso se hace solo desde aquí.',
      revoke: 'Puedes desvincularla cuando quieras desde esta plataforma.',
      warning: 'Aprueba solo si has sido tú quien ha pedido conectar {{host}}.',
      approve: 'Aprobar la conexión',
      working: 'Conectando…',
      cancel: 'Cancelar',
      home: 'Ir al panel',
      invalid:
        'El enlace de conexión no es válido o está incompleto. Vuelve al plugin de tu WordPress y pulsa «Conectar con SiteNorma» otra vez.',
      errors: {
        generic: 'No se ha podido aprobar la conexión. Inténtalo de nuevo dentro de un momento.',
        permiso:
          'Tu rol no permite vincular webs. Pide a un editor, administrador o propietario que lo haga.',
        'limite-webs':
          'Has alcanzado el máximo de webs vinculadas de tu tarifa. Desvincula alguna o cambia de tarifa.',
        callback: 'La dirección de retorno no pertenece a esa web, así que no se puede continuar.',
        url: 'Esa dirección no es pública. Solo se pueden vincular webs accesibles desde Internet.',
        vinculada:
          'Esa web la vinculó otra persona de la organización: solo ella o un administrador puede volver a vincularla.',
        conflicto:
          'Otra vinculación de esta web se estaba haciendo a la vez. Vuelve a empezar desde el plugin.',
        limite: 'Demasiados intentos. Espera un momento y vuelve a probar.',
      },
    },
  },
  users: {
    title: 'Usuarios',
    intro:
      'Cómo evolucionan las altas en SiteNorma, las cuentas dadas de alta y la tarifa que tiene cada una. Solo los superadministradores ven esta página.',
    tableLabel: 'Usuarios del sistema (la tabla se desplaza)',
    count_one: '{{count}} usuario',
    count_other: '{{count}} usuarios',
    columns: {
      user: 'Usuario',
      verified: 'Email verificado',
      organizations: 'Organizaciones',
      signedUp: 'Alta',
      sites: 'Webs',
      scans: 'Escaneos',
      lastSeen: 'Última actividad',
      status: 'Estado',
      plan: 'Tarifa',
    },
    verifiedYes: 'Sí',
    verifiedNo: 'No',
    noOrganizations: 'Ninguna',
    neverSeen: 'Nunca',
    planOf: 'Tarifa de {{name}}',
    limitMonth: '{{count}} páginas al mes',
    limitNone: 'Sin límites',
    infinite: 'Activar tarifa infinita',
    infiniteOn: 'Tarifa infinita activa',
    saved: 'Tarifa de {{name}} cambiada a {{plan}}.',
    error: 'No se ha podido cambiar la tarifa. Inténtalo de nuevo.',
    plans: {
      gratis: 'Gratis',
      pro: 'Pro',
      agencia: 'Agencia',
      'a-medida': 'A medida',
      infinita: 'Infinita',
    },
    wordpress: {
      title: 'Instalaciones de WordPress',
      intro:
        'Webs vinculadas con el plugin en todas las cuentas. Al desvincular una, el plugin deja de mostrar resultados en su siguiente petición; la web y su historial se conservan.',
      tableLabel: 'Instalaciones de WordPress vinculadas (la tabla se desplaza)',
      empty: 'No hay ninguna instalación vinculada.',
      organization: 'Organización',
      unlinkBody:
        'Esta instalación dejará de funcionar de inmediato aunque la cuenta siga activa. Queda registrado en el historial de cambios.',
    },
    overview: {
      title: 'Altas',
      period: 'Periodo de los gráficos',
      lastDays_one: 'Último día',
      lastDays_other: 'Últimos {{count}} días',
    },
    kpi: {
      accounts: 'Cuentas en total',
      last7: 'Altas en 7 días',
      last30: 'Altas en 30 días',
      trend: '{{change}} respecto a los 7 días anteriores ({{previous}})',
      waitlist: 'Lista de espera, 30 días',
      audits: 'Auditorías gratuitas, 30 días',
      total_one: '{{count}} en total',
      total_other: '{{count}} en total',
      blocked: 'Cuentas bloqueadas',
    },
    chart: {
      signups: 'Altas de cuentas por día',
      signupsColumn: 'Altas',
      waitlist: 'Altas en la lista de espera por día',
      waitlistColumn: 'En la lista de espera',
      label: '{{title}}, del {{from}} al {{to}}: {{total}} en total, máximo {{peak}} en un día.',
      peak: 'Máximo: {{count}} en un día',
      data: 'Ver los datos del gráfico',
      day: 'Día',
    },
    funnel: {
      title: 'Qué pasa después del alta',
      intro: 'Cuentas que han llegado a cada paso, sobre el total de altas.',
      signedUp: 'Alta',
      verified: 'Email verificado',
      organization: 'Pertenecen a una organización',
      site: 'Han añadido una web',
      scan: 'Han lanzado un escaneo',
      value: '{{count}} · {{percent}} %',
    },
    filters: {
      search: 'Buscar por nombre, email u organización',
      show: 'Mostrar',
      all: 'Todas las cuentas',
      unverified: 'Sin email verificado',
      noSite: 'Sin ninguna web',
      blocked: 'Bloqueadas',
      shown: 'Se muestran {{count}} de {{total}} usuarios.',
    },
    active: 'Activa',
    blocked: 'Bloqueada',
    administrator: 'Administrador',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    blockTitle: '¿Bloquear a {{name}}?',
    blockBody:
      'No podrá iniciar sesión y se cerrarán las sesiones que tenga abiertas. Sus datos no se borran y puedes desbloquear la cuenta cuando quieras.',
    blockConfirm: 'Bloquear',
    cancel: 'Cancelar',
    blockedDone: '{{name}} está bloqueada.',
    unblockedDone: '{{name}} puede volver a entrar.',
    blockError: 'No se ha podido cambiar el estado de la cuenta. Inténtalo de nuevo.',
  },
  members: {
    tableLabel: 'Personas de la organización (la tabla se desplaza)',
    title: 'Organización: {{name}}',
    membersTitle: 'Personas',
    name: 'Nombre',
    email: 'Email',
    role: 'Rol',
    roleOf: 'Rol de {{name}}',
    actions: 'Acciones',
    you: '(tú)',
    remove: 'Quitar',
    removeOf: 'Quitar a {{name}}',
    removeTitle: '¿Quitar a {{name}} de la organización?',
    removeIntro:
      'Dejará de ver las webs y los análisis de la organización. Puedes volver a invitarla más tarde.',
    removeConfirm: 'Quitar',
    cancel: 'Cancelar',
    roleSaved: 'Rol de {{name}} cambiado a {{role}}.',
    removed: '{{name}} ya no forma parte de la organización.',
    add: 'Añadir persona',
    invitationsTitle: 'Invitaciones pendientes',
    invitationItem: '{{email}} · {{role}} · caduca el {{date}}',
    cancelInvitation: 'Cancelar la invitación',
    cancelInvitationOf: 'Cancelar la invitación a {{email}}',
    invitationCancelled: 'Invitación a {{email}} cancelada.',
    inviteTitle: 'Invitar a una persona',
    inviteIntro: 'Le enviaremos un email con un enlace para unirse. Caduca en 48 horas.',
    inviteEmail: 'Email',
    inviteRole: 'Rol',
    inviteSubmit: 'Enviar invitación',
    invited: 'Invitación enviada a {{email}}.',
    roleHints: {
      owner: 'Todo, incluido eliminar la organización.',
      admin: 'Todo menos eliminar la organización: webs, análisis y personas.',
      editor: 'Añadir, verificar y analizar webs, y trabajar sus problemas.',
      viewer: 'Solo consulta.',
    },
    errors: {
      generic: 'No se ha podido hacer el cambio. Puede que tu rol no lo permita.',
      already: 'Esa persona ya forma parte de la organización o ya tiene una invitación.',
    },
  },
  report: {
    download: 'Descargar informe en PDF',
    working: 'Preparando el informe…',
    started: 'Preparando el informe en PDF. Puede tardar unos segundos.',
    ready: 'Informe descargado.',
    note: '',
    errors: {
      informe: 'No se ha podido preparar el informe. Inténtalo de nuevo en unos minutos.',
      limite: 'Has pedido muchos informes de esta web. Vuelve a probar dentro de una hora.',
      'sin-terminar': 'El análisis todavía no ha terminado.',
    },
  },
  scans: {
    title: 'Análisis',
    emptyTitle: 'Analiza tu web',
    emptyText: 'Elige el tipo y revisa las páginas antes de empezar.',
    prepareAgain: 'Nuevo análisis',
    historyCheck: 'Solo comprobación',
    prepare: {
      action: 'Analizar mi web',
      title: 'Prepara tu análisis',
      loadFailed: 'No hemos podido preparar el resumen. No se ha iniciado nada.',
      profile: 'Perfil normativo',
      profileUnset:
        'Todavía no has elegido un perfil normativo. Indica qué normativa se toma como referencia. Después podrás cambiarlo en los ajustes de la web.',
      scopeTitle: 'Tipo de análisis',
      summaryTitle: 'Resumen',
      next: 'Siguiente',
      back: 'Anterior',
      modes: {
        pagina: {
          label: 'Una página',
          hint: 'Analiza una página de tu web.',
        },
        rapido: {
          label: 'Análisis rápido',
          hint: 'Analiza hasta {{count}} páginas de tu web.',
        },
        completo: {
          label: 'Análisis completo',
          hint: 'Analiza hasta {{count}} páginas de tu web.',
        },
      },
      needsOwnership: 'Requiere verificar la propiedad.',
      verifyAction: 'Verificar mi web',
      checks:
        'Analizaremos automáticamente la accesibilidad según {{standard}}. Algunos aspectos requieren revisión manual.',
      methodology: 'Cómo analizamos tu web',
      analysisLimitTitle: 'Límite por análisis',
      analysisLimit_one: 'Hasta {{count}} página con la opción seleccionada.',
      analysisLimit_other: 'Hasta {{count}} páginas con la opción seleccionada.',
      analysisLimitExact_one: 'Utilizará {{count}} página.',
      analysisLimitExact_other: 'Utilizará {{count}} páginas.',
      monthlyQuotaTitle: 'Cuota mensual',
      monthlyUsedOf: '{{used}} de {{limit}} páginas utilizadas.',
      monthlyAvailable_one: '{{count}} página disponible.',
      monthlyAvailable_other: '{{count}} páginas disponibles.',
      monthlyUnlimited: 'Sin límite de páginas.',
      monthlyAnalysed_one: '{{count}} página analizada este mes.',
      monthlyAnalysed_other: '{{count}} páginas analizadas este mes.',
      optionOverQuota:
        'El límite por análisis es de {{max}} páginas y te quedan {{remaining}} páginas disponibles en la cuota mensual.',
      pagesHelp: 'Cómo contamos las páginas',
      pages: {
        title: '¿Qué páginas quieres analizar?',
        how: 'Cómo se eligen',
        auto: {
          label: 'Selección automática',
          hint_one:
            'SiteNorma parte de la página inicial y elige 1 página representativa (mapa del sitio y enlaces de la portada).',
          hint_other:
            'SiteNorma parte de la página inicial y elige hasta {{count}} páginas representativas (mapa del sitio y enlaces de la portada).',
        },
        manual: {
          label: 'Seleccionar páginas',
          hint_one: 'Elige 1 dirección de tu web.',
          hint_other: 'Elige hasta {{count}} direcciones de tu web.',
          paidOnly: 'Disponible en los planes de pago.',
        },
        autoOne: 'Se analizará la página inicial de la web: {{url}}.',
        autoMulti:
          'SiteNorma detectará páginas de tu web y elegirá hasta {{count}} de las más representativas.',
        search: 'Buscar páginas',
        searchPlaceholder: 'Título o dirección',
        listLabel: 'Páginas detectadas o analizadas anteriormente',
        chosen: 'Seleccionadas: {{count}} de {{max}}',
        empty: 'No hay páginas que coincidan. Puedes añadir una dirección abajo.',
        addLabel: 'Añadir una dirección',
        addHint:
          'Debe pertenecer al mismo dominio de la web. Por ejemplo, /contacto o https://tuweb.com/contacto',
        addPlaceholder: 'https://tuweb.com/contacto',
        addAction: 'Añadir a la selección',
        addInvalid: 'Introduce una dirección de esta web, por ejemplo /contacto o https://tuweb.com/contacto',
        addDuplicate: 'Esa dirección ya está en la selección.',
        addLimit_one: 'Este análisis admite como máximo {{count}} página.',
        addLimit_other: 'Este análisis admite como máximo {{count}} páginas.',
        summaryTitle: 'Resumen de la selección',
        summaryCount_one: '{{count}} página seleccionada:',
        summaryCount_other: '{{count}} páginas seleccionadas:',
      },
      noPages: {
        title: 'No te quedan páginas disponibles',
        text: 'Has utilizado la cuota mensual de este mes. El contador se reinicia el {{date}}.',
      },
      insufficient:
        'No tienes páginas suficientes en la cuota mensual: el límite por análisis es de {{planned}} y te quedan {{remaining}} páginas disponibles. El contador se reinicia el {{date}}.',
      useOnePage: 'Analizar solo una página',
      seePlans: 'Ver planes',
      check: {
        mode: 'Comprobar la corrección',
        modeHint_one:
          'Solo la página donde está la corrección que quieres comprobar, en escritorio y en móvil.',
        modeHint_other:
          'Solo las {{count}} páginas donde están las correcciones que quieres comprobar, en escritorio y en móvil.',
        title: 'Qué se va a comprobar',
        intro:
          'Es una comprobación de correcciones, no un análisis de toda tu web: solo revisa las páginas de estos elementos y no buscará problemas en otras.',
        elements_one: '{{count}} elemento',
        elements_other: '{{count}} elementos',
        pagesTitle: 'Páginas que se analizarán',
        devices: 'Dispositivos: {{list}}.',
        conditionsTitle: 'En qué condiciones',
        conditions:
          'Cada página se carga como la ve una visita nueva, sin sesión iniciada, en escritorio y en móvil. Si un elemento solo aparece en una ventana emergente o tras iniciar sesión, el resultado será «No confirmado automáticamente» o «Requiere revisión manual», nunca «corregido».',
        scope_one: 'Alcance: {{count}} página de las que tiene tu web.',
        scope_other: 'Alcance: {{count}} páginas de las que tiene tu web.',
        skipped_one: '{{count}} elemento no se comprobará (está archivado o descartado).',
        skipped_other: '{{count}} elementos no se comprobarán (están archivados o descartados).',
        tooMany:
          'Hay correcciones en {{count}} páginas y una comprobación puede revisar como máximo {{max}}. Comprueba menos elementos cada vez.',
        nothing: 'No hay nada que comprobar con los elementos elegidos.',
        other: 'Otros análisis',
        result:
          'Al terminar, cada elemento mostrará su resultado: «Sigue detectándose», «No detectado en la última comprobación», «No confirmado automáticamente» o «Requiere revisión manual». Solo una comprobación comparable que no lo detecte permite archivar el trabajo.',
      },
      start: 'Iniciar análisis',
      startAuto_one: 'Analizar 1 página',
      startAuto_other: 'Analizar hasta {{count}} páginas',
      startExact_one: 'Analizar 1 página',
      startExact_other: 'Analizar {{count}} páginas',
      starting: 'Iniciando análisis…',
      cancel: 'Cancelar',
      startFailed:
        'No hemos podido iniciar el análisis. No se ha usado ninguna página: puedes volver a intentarlo.',
    },
    errors: {
      'en-curso': 'Ya hay un análisis en marcha para esta web.',
      verificacion: 'Para el escaneo completo, la propiedad de la web tiene que estar verificada.',
      limite: 'Has lanzado muchos análisis hoy. Vuelve a probar mañana.',
      saldo: 'No tienes páginas suficientes este mes para este análisis. No se ha iniciado nada.',
      permiso: 'Tu rol no permite analizar webs.',
      plan: 'Elegir las páginas a mano está disponible en los planes de pago. No se ha iniciado nada.',
      urls: 'Alguna dirección no es válida, está duplicada o no pertenece a esta web. No se ha iniciado nada.',
      'limite-paginas':
        'Has elegido más páginas de las que admite este tipo de análisis. No se ha iniciado nada.',
      'nada-que-comprobar':
        'No hay nada que comprobar: los elementos elegidos están archivados, descartados o ya no existen.',
      'demasiadas-paginas': 'Esas correcciones están en demasiadas páginas para una sola comprobación.',
      'no-completable': 'Solo se puede completar un análisis completo que haya terminado parcialmente.',
      'nada-que-completar': 'No quedan páginas pendientes que completar en este análisis.',
    },
    types: {
      pagina: 'Una página',
      rapido: 'Rápido',
      completo: 'Completo',
      personalizado: 'Personalizado',
      comprobacion: 'Comprobación de correcciones',
    },
    latestTitle: 'Último análisis',
    lastAvailableTitle: 'Último resultado disponible',
    meta: '{{date}} · {{type}}',
    scoreNote: 'No equivale a la conformidad legal.',
    summary: {
      kinds: {
        rapido: 'rápido',
        completo: 'completo',
        personalizado: 'personalizado',
        comprobacion: 'de comprobación',
      },
      pages_one: '{{count}} página',
      pages_other: '{{count}} páginas',
      found_one: 'El escaneo {{kind}} de {{pages}} ha detectado {{count}} problema de accesibilidad.',
      found_other: 'El escaneo {{kind}} de {{pages}} ha detectado {{count}} problemas de accesibilidad.',
      none: 'El escaneo {{kind}} de {{pages}} no ha detectado problemas de accesibilidad con las pruebas automáticas.',
      nothing: 'El escaneo {{kind}} no ha podido analizar ninguna página.',
      pendingReview: 'Hay comprobaciones pendientes de revisión manual.',
    },
    noScore: 'Sin estimación: no se ha podido analizar ninguna página.',
    blocked:
      'La web ha bloqueado el análisis automático en {{count}} página(s). Si es por su robots.txt, verifica la propiedad de la web (los análisis de webs verificadas no dependen de él) o permite a SiteNormaBot en ese archivo.',
    limited:
      'La web limitó las peticiones de SiteNorma en {{count}} página(s): no se han analizado ni cuentan en la estimación. No es un problema de la web.',
    partial:
      'En {{count}} página(s) la web limitó las peticiones: el análisis se hizo con la página cargada, pero la captura puede mostrar imágenes sin cargar. No contamos esos rechazos como problemas.',
    details: 'Ver el informe completo',
    history: 'Análisis anteriores',
    historyItem: '{{date}} · {{type}}',
    estimate: 'Estimación automática de accesibilidad',
    bands: {
      excelente: 'Excelente',
      bueno: 'Bueno',
      mejorable: 'Mejorable',
      deficiente: 'Deficiente',
      'revision-pendiente': 'Revisión manual pendiente',
      'sin-datos': 'Sin datos',
    },
    modules: { seo: 'SEO', quality: 'Calidad' },
    allPages: 'Ver las {{count}} páginas',
    pagesHeading: 'Páginas analizadas',
    about: 'Sobre este análisis',
    seeAllProblems: 'Ver problemas',
    trend: 'Evolución de la estimación',
    historyScore: 'Estimación: {{score}}/100',
  },
  scan: {
    title: 'Análisis del {{date}}',
    technical: 'Detalles técnicos',
    back: 'Volver a Análisis',
    pageBlocked: 'Bloqueada: {{reason}}',
    pageError: 'Con error: {{error}}',
    issuesTitle: 'Problemas',
    groups: {
      violations: 'Problemas de WCAG',
      review: 'Requieren revisión manual',
      bestPractices: 'Buenas prácticas',
      seo: 'SEO',
      quality: 'Calidad',
    },
    empty: 'Ninguna.',
    severity: { critica: 'Crítica', grave: 'Grave', moderada: 'Moderada', leve: 'Leve' },
    criteria: 'WCAG {{list}}',
    devices: { escritorio: 'escritorio', movil: 'móvil' },
    where: 'En {{pages}} página(s) · {{nodes}} elemento(s) · {{devices}}',
    fix: 'Cómo corregirlo',
    examples: 'Ejemplos',
    exampleOn: 'En {{url}} ({{device}})',
    engineScore:
      'Sin contar las detecciones que tu equipo ha descartado con justificación. El motor dio {{score}}/100.',
    discardedNote_one: 'No cuenta {{count}} detección descartada con justificación.',
    discardedNote_other: 'No cuentan {{count}} detecciones descartadas con justificación.',
    discardedMethod: 'Cómo se aplican los descartes',
    groupCount_one: '({{count}} problema · {{rules}} regla)',
    groupCount_other: '({{count}} problemas · {{rules}} reglas)',
    rule: {
      variant: 'Variante {{index}} de {{total}}',
      where: 'En {{pages}} página(s) · {{nodes}} elemento(s)',
      wherePages: 'En {{pages}} página(s)',
      onPage_one: '{{count}} elemento en esta página',
      onPage_other: '{{count}} elementos en esta página',
      onPageAtLeast_one: 'Al menos {{count}} elemento en esta página',
      onPageAtLeast_other: 'Al menos {{count}} elementos en esta página',
      elsewhere_one: 'también en {{count}} página más',
      elsewhere_other: 'también en {{count}} páginas más',
      thisPageAndMore_one: 'En esta página y en {{count}} más',
      thisPageAndMore_other: 'En esta página y en {{count}} más',
      thisPage: 'En esta página',
      variants_one: '{{count}} variante',
      variants_other: '{{count}} variantes',
    },
    elementsOnPage_one: 'Su elemento en esta página',
    elementsOnPage_other: 'Sus {{count}} elementos en esta página',
    charts: {
      severity: 'Problemas por gravedad',
      principles: 'Problemas por principio de las WCAG',
      top: 'Los problemas más repetidos',
      topHint: 'Número de páginas en las que aparece cada una.',
      pageSeverity: 'Problemas de esta página',
    },
    principles: { 1: 'Perceptible', 2: 'Operable', 3: 'Comprensible', 4: 'Robusto' },
    map: {
      title: 'Mapa de páginas',
      hint: 'Cada página, con su captura y del color de su problema más grave. Púlsala para ver sus datos.',
      noCaptures:
        'Las capturas de este análisis ya no están disponibles: solo se guardan las de los dos últimos análisis de cada web.',
    },
    filters: {
      severity: 'Filtrar por gravedad',
      search: 'Buscar un problema',
      results_one: '{{count}} problema',
      results_other: '{{count}} problemas',
    },
    pages: {
      empty: 'Todavía no hay páginas analizadas. Empieza con un escaneo desde Análisis.',
      notReady: 'Este análisis todavía no ha terminado: sus páginas aparecerán al acabar.',
      failed: 'No se ha podido completar este análisis, así que no hay páginas analizadas que mostrar.',
      none: 'Este análisis no tiene páginas.',
      list: 'Páginas del análisis',
      sort: {
        label: 'Ordenar páginas',
        prioridad: 'Por prioridad',
        nombre: 'Por nombre',
        pendientes: 'Por problemas pendientes',
        fecha: 'Por fecha del último análisis',
      },
      search: 'Buscar una página',
      found: 'Páginas encontradas: {{count}}',
      newTab: '(se abre en una pestaña nueva)',
      elements_one: '{{count}} elemento afectado',
      elements_other: '{{count}} elementos afectados',
      review_one: '{{count}} por revisar',
      review_other: '{{count}} por revisar',
      issues_one: 'Problemas de esta página ({{count}})',
      issues_other: 'Problemas de esta página ({{count}})',
      issuesHint:
        'Agrupadas por regla. Abre una para ver cómo corregirla y sus elementos; «Señalar» los marca en la captura.',
      clean:
        'No hemos detectado problemas en esta página. Las pruebas automáticas no lo comprueban todo: la revisión manual sigue pendiente.',
    },
    facts: {
      status: 'Respuesta',
      load: 'Carga',
      ttfb: 'Primer byte',
      bytes: 'Peso',
      requests: 'Peticiones',
      lang: 'Idioma',
      features: 'Contiene: {{list}}.',
    },
    features: { forms: 'formularios', video: 'vídeo', audio: 'audio', iframes: 'iframes' },
    pageBlockedShort: 'Bloqueada',
    pageErrorShort: 'Con error',
    elementOn: 'Elemento {{number}} ({{device}})',
  },
  viz: {
    ring: {
      none: 'Sin estimación: no se ha podido analizar ninguna página.',
      pendingHint:
        'Los {{pending}} puntos pendientes se suman al completar la revisión manual. Hasta entonces, la estimación no puede superar {{max}} de 100.',
      full: 'Estimación automática: {{score}} de 100. {{earned}} puntos obtenidos, {{lost}} perdidos y {{pending}} pendientes de revisión manual.',
      short: 'Estimación automática: {{score}} de 100.',
      parts: {
        earned: 'Puntos obtenidos',
        lost: 'Perdidos',
        manual: 'Revisión manual',
        pending: 'Pendientes de revisión manual',
      },
    },
    points_one: '{{count}} punto',
    points_other: '{{count}} puntos',
    severities: { critica: 'Críticos', grave: 'Graves', moderada: 'Moderados', leve: 'Leves' },
    review: 'Por revisar',
    chips: {
      ok: 'Sin problemas detectados',
      review_one: '{{count}} por revisar',
      review_other: '{{count}} por revisar',
      critica_one: '{{count}} problema crítico',
      critica_other: '{{count}} problemas críticos',
      grave_one: '{{count}} problema grave',
      grave_other: '{{count}} problemas graves',
      moderada_one: '{{count}} problema moderado',
      moderada_other: '{{count}} problemas moderados',
      leve_one: '{{count}} problema leve',
      leve_other: '{{count}} problemas leves',
    },
    module: { label: '{{label}}: {{score}} de 100', none: '{{label}}: sin datos' },
    trend: {
      label_one: 'Evolución de la estimación en {{count}} análisis: {{to}} ({{end}}).',
      label_other:
        'Evolución de la estimación en {{count}} análisis: de {{from}} ({{start}}) a {{to}} ({{end}}).',
    },
  },
  live: {
    mosaic: 'Páginas del análisis',
    analysing: 'Analizando…',
    analysed: 'Analizada',
    waiting: 'En cola',
    moreWaiting_one: 'y {{count}} más en cola',
    moreWaiting_other: 'y {{count}} más en cola',
    blocked: 'Bloqueada',
    error: 'Con error',
  },
  results: {
    backToResults: 'Volver a los resultados del análisis',
    backToPages: 'Volver a todas las páginas',
    summaries: 'Resúmenes del análisis',
    pagesCount_one: '{{count}} página',
    pagesCount_other: '{{count}} páginas',
    priority: {
      alta: 'Prioridad alta',
      media: 'Prioridad media',
      baja: 'Prioridad baja',
      pendiente: 'Prioridad pendiente de revisión',
    },
    priorityWhy: {
      alta: 'Puede impedir que algunas personas usen esta parte de la web.',
      media: 'Dificulta el uso a algunas personas, aunque suele haber otra forma de continuar.',
      baja: 'Es una molestia menor o una mejora recomendable.',
      pendiente:
        'El análisis automático no ha podido decidir si es un problema: una persona tiene que comprobarlo.',
    },
    priorityWhyOther: {
      alta: 'Es importante para el funcionamiento o la visibilidad de la web. No es un problema de accesibilidad.',
      media: 'Conviene corregirlo, pero no es urgente. No es un problema de accesibilidad.',
      baja: 'Es una mejora menor. No es un problema de accesibilidad.',
    },
    priorityWhyPractice: {
      alta: 'Es una buena práctica importante para quien usa tecnologías de apoyo, aunque no es un incumplimiento directo de las WCAG.',
      media: 'Es una buena práctica recomendable, aunque no es un incumplimiento directo de las WCAG.',
      baja: 'Es una mejora menor de buena práctica, no un incumplimiento de las WCAG.',
    },
    why: 'Por qué:',
    affects: 'Afecta sobre todo a personas con: {{who}}.',
    origin: {
      automatic: 'Detectado automáticamente',
      review: 'Detección automática · requiere comprobación manual',
      manual: 'Detectado en revisión manual',
    },
    actions: { fix: 'Ver solución', check: 'Ver y comprobar' },
    card: {
      elements_one: '{{count}} elemento afectado',
      elements_other: '{{count}} elementos afectados',
      elementsAtLeast_one: '{{count}}+ elementos afectados',
      elementsAtLeast_other: '{{count}}+ elementos afectados',
      review_one: '{{count}} elemento por comprobar',
      review_other: '{{count}} elementos por comprobar',
      reviewAtLeast_one: '{{count}}+ elementos por comprobar',
      reviewAtLeast_other: '{{count}}+ elementos por comprobar',
    },
    more: {
      title: 'Otras comprobaciones',
      show: 'Mostrar',
    },
    issue: {
      problem: 'Problema',
      noPageData: 'No hay datos de esta página para este problema.',
      pageOf_one: 'Página afectada',
      pageOf_other: 'Afecta a {{count}} páginas: elige una',
      fix: 'Cómo corregirlo',
      check: 'Cómo comprobarlo',
      wcag: 'Referencia WCAG',
      elements: 'Elementos afectados',
      pages: 'Páginas afectadas',
      technical: 'Detalles técnicos',
      moreElements: 'Y {{count}} elementos más. Los encuentras en las páginas afectadas.',
      seeInPage: 'Ver en la página',
      sharedOne: 'Este problema afecta a {{pages}} páginas y se encuentra en un componente compartido.',
      sharedMany:
        'Este problema afecta a {{pages}} páginas y se encuentra en {{components}} componentes compartidos.',
      seePages_one: 'Ver la página afectada',
      seePages_other: 'Ver las {{count}} páginas afectadas',
      sharedSelector: 'Selector del componente compartido',
      area: 'Área',
      severity: 'Gravedad',
      type: 'Tipo',
      showing: 'Mostrando {{shown}} de {{total}}',
      areas: { todas: 'Todas', bestPractices: 'Buenas prácticas', seo: 'SEO', quality: 'Calidad' },
      tracking: {
        title: 'Seguimiento de este problema',
        hint: 'Trabajo, validación y verificación',
        none: 'Sin seguimiento',
        validation: 'Confirmadas: {{confirmed}} · Descartadas: {{discarded}}',
        noDecisions: 'Sin decisiones',
        verificationTitle: 'Verificación de la corrección',
        verification:
          'Verificados: {{verified}} · Siguen detectándose: {{persists}} · Pendientes: {{pending}}',
      },
    },
    shared: {
      chip: 'Problema global',
      title: 'Elementos compartidos',
      intro:
        'El mismo elemento, con la misma estructura, aparece en varias páginas: lo causa un componente compartido (cabecera, pie, menú, formulario…). Es un único problema, que se gestiona desde un solo sitio y se corrige una sola vez.',
      zone: 'En {{zone}}',
      pages_one: 'En {{count}} página',
      pages_other: 'En {{count}} páginas',
      identical: 'El código es idéntico en todas.',
      textChanges:
        'Misma estructura; cambian el texto o las direcciones entre páginas (por ejemplo, entre idiomas).',
      seePages: 'Ver las páginas',
      separately:
        'Se sigue y se corrige desde un único sitio: lo que indiques se aplica a todas las páginas, pero cada una solo se da por verificada cuando un análisis nuevo ya no lo detecta en ella.',
      owner: 'Se gestiona desde {{page}}',
      ownerGlobal: 'Se gestiona desde la sección de problemas globales',
      elementIn_other: 'Elemento compartido en {{count}} páginas',
      alsoHere_one: 'Otro problema global afecta también a esta página; se gestiona desde otro sitio.',
      alsoHere_other:
        '{{count}} problemas globales afectan también a esta página; se gestionan desde otro sitio.',
    },
    globals: {
      title: 'Problemas globales',
      intro:
        'Afectan a elementos compartidos por varias páginas (cabecera, pie, menú…). Se muestran una sola vez y se gestionan desde un único sitio.',
      manage: 'Ver y gestionar',
      where: 'Se gestiona en {{page}}',
      whereGlobal: 'Sin la página de inicio entre ellas: se gestiona en {{page}}',
    },
    counts: {
      pageOnly: 'Afecta a esta página',
      pagesOnly: 'Afecta a {{pages}}',
      elementsOnly_one: '{{count}} elemento',
      elementsOnly_other: '{{count}} elementos',
      elementsOnlyAtLeast_one: 'al menos {{count}} elemento',
      elementsOnlyAtLeast_other: 'al menos {{count}} elementos',
      affectsPage: 'afecta a la página',
      languages_one: '{{count}} idioma: {{list}}',
      languages_other: '{{count}} idiomas: {{list}}',
    },
    devices: { both: 'en escritorio y móvil', desktop: 'solo en escritorio', mobile: 'solo en móvil' },
    manual: {
      figures: { registered: 'Revisadas', pending: 'Pendientes', decide: 'Elementos por decidir' },
      open: 'Ver las comprobaciones manuales',
      title: 'Comprobaciones manuales',
      progress: '{{done}} de {{total}} criterios con alguna revisión registrada',
      pending_one: '{{count}} criterio pendiente de revisión manual.',
      pending_other: '{{count}} criterios pendientes de revisión manual.',
      itemsDecided:
        'De {{total}} elementos que el análisis no ha podido decidir, tu equipo ha confirmado o descartado {{decided}}.',
      hint: 'Las pruebas automáticas no sustituyen la revisión manual: ningún criterio se da por cumplido hasta que una persona lo revisa.',
      intro:
        'La revisión manual comprueba, criterio a criterio, lo que ninguna herramienta automática puede decidir. Esta lista recoge los criterios de la norma de tu web y en qué punto está cada uno: el resultado del análisis automático y el de la revisión manual van por separado.',
      status: {
        incumple: 'Incumple (detectado)',
        'sin-incidencias': 'Sin problemas automáticos: requiere revisión manual',
        pendiente: 'Pendiente de revisión manual',
      },
      statusHelp: {
        incumple: 'El análisis automático ha encontrado al menos un problema que afecta a este criterio.',
        'sin-incidencias':
          'Las comprobaciones automáticas aplicables no han encontrado fallos, pero eso no basta: hay que revisarlo a mano.',
        pendiente:
          'Ninguna prueba automática lo ha comprobado en estas páginas, o no se puede comprobar con herramientas automáticas.',
      },
      toReview_one: '{{count}} aspecto por decidir a mano',
      toReview_other: '{{count}} aspectos por decidir a mano',
    },
    summary: {
      globalProblems_one: '1 afecta a varias páginas',
      globalProblems_other: '{{count}} afectan a varias páginas',
      title: 'Resumen',
      priority: 'Prioridad',
      priorities: {
        alta: '{{count}} de prioridad alta',
        media: '{{count}} de prioridad media',
        baja: '{{count}} de prioridad baja',
      },
      problems: 'Tipos de problema',
      problemsHelp: 'Qué es un tipo de problema',
      problemsHelpText: 'Una misma clase de fallo, aunque se repita en varias páginas o elementos.',
      elements: 'Elementos afectados',
      elementsHelp: 'Qué es un elemento afectado',
      elementsHelpText:
        'Una imagen, un botón u otro elemento con fallos. Si falla en escritorio y en móvil, cuenta una vez.',
      atLeast: 'Al menos',
      pages: 'Páginas con problemas',
      sharedElements: '{{count}} se repiten en otras páginas',
      pagesOfTotal: '{{count}} de {{total}} analizadas',
      repeated:
        'Un mismo elemento puede fallar en varios tipos de problema, y en el total se cuenta una sola vez. Por eso la suma da {{summed}} y el total es {{total}}.',
      none_one: 'No se han detectado problemas automáticos en la página analizada.',
      none_other: 'No se han detectado problemas automáticos en las {{count}} páginas analizadas.',
      how: {
        title: 'Cómo se cuentan estas cifras',
        problem: {
          term: 'Tipo de problema',
          text: 'Una misma clase de fallo (por ejemplo, «Imagen sin texto alternativo»), aunque se repita.',
        },
        element: {
          term: 'Elemento afectado',
          text: 'Una imagen, un botón u otro elemento con fallos. Si falla en escritorio y en móvil, cuenta una vez.',
        },
        atLeast: {
          term: 'El signo «+»',
          text: 'El análisis deja de contar cuando hay muchos elementos en una página; el total real puede ser mayor.',
        },
        appearance: {
          term: 'Aparición',
          text: 'Cada vez que una comprobación encuentra un elemento (por dispositivo). Se ve en el detalle técnico.',
        },
        devices: {
          term: 'Dispositivos',
          text: 'Las cifras suman escritorio y móvil, salvo que un filtro diga otra cosa.',
        },
        pages: {
          term: 'Páginas con problemas',
          text: 'Páginas de este análisis con al menos un tipo de problema. La pestaña «Páginas» lista todas las analizadas alguna vez.',
        },
        pageCount: {
          term: 'Número en cada página',
          text: 'Tipos de problema distintos en esa página. La suma de páginas puede superar el total del análisis.',
        },
        repeated: {
          term: 'Un elemento en varios tipos',
        },
      },
    },
    pageSummary: {
      global_one: 'de ellos, 1 global',
      global_other: 'de ellos, {{count}} globales',
      title: 'Resumen de esta página',
      none: 'El análisis automático no ha detectado problemas de accesibilidad en esta página. Esto no significa que sea totalmente accesible.',
      problems_one: '{{count}} problema detectado',
      problems_other: '{{count}} problemas detectados',
      elements_one: '{{count}}{{plus}} elemento afectado',
      elements_other: '{{count}}{{plus}} elementos afectados',
      priorities: {
        alta: 'Prioridad alta: {{count}}',
        media: 'Prioridad media: {{count}}',
        baja: 'Prioridad baja: {{count}}',
      },
    },
    start: {
      title: 'Por dónde empezar',
      intro:
        'Empieza por estos problemas: son los de mayor prioridad y, a igualdad, los que afectan a más elementos y páginas.',
      counts_one: '{{count}} elemento afectado en {{pages}}',
      counts_other: '{{count}} elementos afectados en {{pages}}',
      countsAtLeast_one: 'Al menos {{count}} elemento afectado en {{pages}}',
      countsAtLeast_other: 'Al menos {{count}} elementos afectados en {{pages}}',
      how: {
        title: '¿Cómo se decide la prioridad?',
        intro:
          'La prioridad indica cuánto dificulta un problema el uso de la web, según el impacto que detecta la prueba. No mide el riesgo legal.',
        alta: 'Puede impedir que alguien complete una tarea (por ejemplo, un botón que el lector de pantalla no sabe anunciar).',
        media: 'Dificulta el uso, pero normalmente hay otra forma de continuar.',
        baja: 'Una molestia menor o una mejora recomendable.',
        pendiente: 'El análisis no puede decidir si es un problema: hace falta que una persona lo revise.',
        order:
          'Dentro de cada prioridad van primero los que afectan a más elementos, después a más páginas y, por último, por orden alfabético.',
      },
    },
    score: {
      title: 'Estimación automática',
      value: '{{score}}/100',
      intro: 'De 0 a 100 puntos. No es un porcentaje de cumplimiento ni la conformidad legal.',
      method: 'Cómo se calcula',
    },
    honesty: {
      text: 'El análisis automático detecta parte de los problemas. Algunos requieren revisión manual.',
      link: 'Cómo analizamos tu web',
    },
    pageCard: {
      onlyGlobal_one: '{{count}} problema global',
      onlyGlobal_other: '{{count}} problemas globales',
      languages: 'Versiones por idioma',
      showLanguage: 'Ver la versión en {{language}}',
      problems_one: '{{count}} problema',
      problems_other: '{{count}} problemas',
      none: 'Sin problemas detectados',
      noneShort: 'Sin problemas',
    },
    context: {
      label: 'Qué se ha analizado',
      date: 'Análisis del {{date}}',
      devices: 'Dispositivos: escritorio y móvil',
      complete: 'Análisis completo',
      partial_one: 'Análisis parcial: falta {{count}} página por analizar',
      partial_other: 'Análisis parcial: faltan {{count}} páginas por analizar',
      previous: 'Resultado anterior',
    },
    previous: {
      title: 'Este es un resultado anterior.',
      text: 'Hay un análisis más reciente, del {{date}}.',
      link: 'Ver el análisis más reciente',
    },
    tabs: {
      label: 'Categorías de resultados',
      problems: 'Problemas detectados',
      passed: 'Comprobaciones sin problemas detectados',
      unchecked: 'Aspectos que no se han podido comprobar',
      manual: 'Comprobaciones manuales',
      other: 'Buenas prácticas, SEO y calidad',
    },
    problems: {
      none: {
        scan: 'El análisis automático no ha detectado problemas de accesibilidad en las páginas analizadas. Esto no significa que la web sea totalmente accesible: faltan las comprobaciones manuales.',
        page: 'El análisis automático no ha detectado problemas de accesibilidad en esta página. Esto no significa que sea totalmente accesible: faltan las comprobaciones manuales.',
      },
    },
    passed: {
      level: 'Nivel {{level}}',
      result: 'Resultado:',
      resultPage: 'La comprobación automática no ha encontrado problemas en esta página.',
      resultPages_one: 'La comprobación automática no ha encontrado problemas en {{count}} página.',
      resultPages_other: 'La comprobación automática no ha encontrado problemas en {{count}} páginas.',
      where:
        'Revisa la página entera: el análisis no guarda los elementos concretos que ha comprobado, así que no se pueden señalar en la captura. No hay nada que corregir aquí, y no significa que el criterio se cumpla del todo: hace falta revisión manual.',
      intro: {
        scan: 'Comprobaciones automáticas que se aplicaron a las páginas analizadas y no encontraron fallos.',
        page: 'Comprobaciones automáticas que se aplicaron a esta página y no encontraron fallos.',
      },
      note: 'Que una comprobación no encuentre fallos no equivale a que se cumpla el criterio: las pruebas automáticas solo detectan una parte de las barreras y los criterios siguen pendientes de revisión manual.',
      unavailable:
        'Este análisis se hizo antes de que guardáramos esta información. Haz un análisis nuevo para ver las comprobaciones sin problemas.',
      none: 'Ninguna comprobación se ha podido aplicar sin encontrar problemas.',
      wcag_one: '{{count}} comprobación de las pautas WCAG',
      wcag_other: '{{count}} comprobaciones de las pautas WCAG',
      practices_one: '{{count}} comprobación de buenas prácticas',
      practices_other: '{{count}} comprobaciones de buenas prácticas',
      inPages_one: 'en {{count}} página',
      inPages_other: 'en {{count}} páginas',
    },
    unchecked: {
      intro:
        'Aquí está lo que el análisis automático no ha podido decidir y lo que no se ha analizado. Nada de esto se da por correcto.',
      byHand: 'Hay que decidirlo a mano ({{count}})',
      byHandHint:
        'El análisis automático no ha podido decidir si esto es un problema. Una persona tiene que comprobarlo y, si quiere, registrar su decisión.',
      noneByHand: 'No hay aspectos pendientes de decidir a mano.',
      pages: 'Páginas que no se han analizado ({{count}})',
      pagesHint: 'Estas páginas no se han analizado, así que no se consideran superadas.',
      noPages: 'Todas las páginas previstas se han analizado.',
    },
    other: {
      intro: 'Comprobaciones que ayudan a mejorar la web pero no son problemas de accesibilidad de las WCAG.',
      note: 'Las buenas prácticas, el SEO y la calidad técnica no cuentan en el resumen de problemas de accesibilidad.',
      bestPractices: 'Buenas prácticas de accesibilidad',
      bestPracticesHint:
        'Mejoran la experiencia con tecnologías de apoyo, pero no incumplen directamente un criterio de las WCAG.',
      seo: 'SEO (visibilidad en buscadores)',
      seoHint: 'Ayudan a que los buscadores encuentren y entiendan la web.',
      quality: 'Calidad técnica',
      qualityHint: 'Errores técnicos, seguridad y cookies de la página.',
      empty: 'Nada que mostrar en este apartado.',
    },
    filters: {
      title: 'Filtrar',
      priority: 'Prioridad',
      device: 'Dispositivo',
      devices: { todos: 'Todos los dispositivos', escritorio: 'Escritorio', movil: 'Móvil' },
      search: 'Buscar por nombre, explicación o criterio WCAG',
      shown: 'Se muestran {{shown}} de {{total}}.',
      clear: 'Quitar filtros',
      noMatch: 'Nada coincide con los filtros. Pulsa «Quitar filtros» para ver todo.',
    },
    detail: {
      title: 'Resultados detallados',
      howToCheck: 'Cómo comprobarlo',
      where: 'Dónde está',
      examples: 'Ejemplos de elementos',
      engineMessage: 'Mensaje técnico del motor',
      elementsHere_one: 'El elemento de esta página',
      elementsHere_other: 'Los {{count}} elementos de esta página',
      technical: 'Detalle técnico',
      rule: 'Regla del motor',
      criteria: 'Criterios WCAG relacionados',
      criterion: 'WCAG {{id}} {{title}} (nivel {{level}})',
      appearances: 'Apariciones',
      appearancesValue_one: '{{count}} aparición',
      appearancesValue_other: '{{count}} apariciones',
      appearancesHelp:
        'Cada vez que la comprobación encuentra un elemento cuenta una aparición: un mismo elemento que falla en escritorio y en móvil suma dos apariciones, pero es un solo elemento.',
      groups: 'Agrupaciones técnicas',
      groupsValue_one: '{{count}} grupo',
      groupsValue_other: '{{count}} grupos',
      groupsHelp:
        'Elementos de la misma regla agrupados por ser del mismo tipo y estar en la misma estructura de página, una relación que comprueba el motor. Cada grupo tiene su propio seguimiento.',
      scopeNote: 'Qué cuenta aquí',
      scopeNoteValue: 'Elementos distintos de todas las páginas analizadas, escritorio y móvil juntos.',
    },
  },
  status: {
    outcomes: {
      queued: 'Análisis en cola',
      running: 'Análisis en curso',
      complete: 'Análisis completado',
      partial: 'Análisis completado parcialmente',
      failed: 'No se ha podido completar el análisis',
    },
    announce: {
      queued: 'Análisis en cola.',
      running: 'Análisis en curso.',
      complete: 'Análisis completado. Ya puedes ver los resultados.',
      partial: 'Análisis completado parcialmente. Revisa qué páginas no se han analizado.',
      failed: 'No se ha podido completar el análisis.',
      refreshed: 'Estado actualizado.',
    },
    identity: {
      url: 'Dirección',
      scope: 'Alcance',
      scopeValue_one: '{{mode}} · hasta {{count}} página, en escritorio y en móvil',
      scopeValue_other: '{{mode}} · hasta {{count}} páginas, en escritorio y en móvil',
      requested: 'Solicitado el',
    },
    modes: {
      pagina: 'Solo la página indicada',
      rapido: 'Análisis rápido',
      completo: 'Análisis completo',
      personalizado: 'Análisis personalizado',
      comprobacion: 'Comprobación de correcciones',
    },
    queued: { text: 'Tu análisis está en cola. Comenzará cuando haya disponibilidad.' },
    leave: 'Puedes salir de esta pantalla. El análisis continuará y podrás consultar su estado desde la web.',
    progress: 'Analizando {{done}}/{{total}}',
    progressEta: {
      seconds: 'Quedan unos {{count}} segundos',
      minutes_one: 'Quedan unos {{count}} minuto',
      minutes_other: 'Quedan unos {{count}} minutos',
    },
    phases: {
      title: 'Fases del análisis',
      queued: 'En cola',
      preparing: 'Preparando el análisis',
      analysing: 'Analizando las páginas',
      finishing: 'Calculando la estimación',
      done: 'completada',
      current: 'fase actual',
    },
    refresh: {
      failed: 'No hemos podido actualizar el estado. Vuelve a intentarlo.',
      action: 'Actualizar estado',
      lastKnown: 'Último estado recibido a las {{time}}. El análisis no se ha detenido por esto.',
    },
    partial: {
      text: 'Analizadas {{done}} de {{total}} páginas.',
      pending_one: 'Falta 1 página: no se considera superada.',
      pending_other: 'Faltan {{count}} páginas: no se consideran superadas.',
      why: 'El análisis no ha podido terminar del todo: alguna página no se ha analizado (por ejemplo, porque se agotó el tiempo). Abajo ves cada una con el motivo.',
      next: 'Vuelve a lanzar el análisis para intentar cubrir las páginas que faltan.',
      nextFull:
        'Este resultado no cuenta como un análisis completo vigente. Vuelve a lanzar un análisis completo.',
      nextFullComplete:
        'Este resultado no cuenta como un análisis completo vigente. Puedes completar solo las páginas pendientes: se reanalizan esas y se conservan las que ya salieron bien. Solo cuentan las páginas que se vuelven a analizar.',
      complete_one: 'Completar 1 página pendiente',
      complete_other: 'Completar {{count}} páginas pendientes',
      completing: 'Completando análisis…',
      completeFailed:
        'No hemos podido completar el análisis. No se ha usado ninguna página: puedes volver a intentarlo.',
    },
    pending: {
      title: 'Páginas sin analizar',
      hint: 'No se han analizado y no cuentan como superadas.',
      more: 'Y {{count}} más.',
    },
    causes: {
      interrupted: 'El análisis se interrumpió antes de terminar y no ha dejado resultados.',
      domain:
        'El dominio de la web no resuelve a una dirección pública. Comprueba que la dirección es correcta y que la web está en línea.',
      limited:
        'La web ha limitado las peticiones automáticas (HTTP 429) y no se ha podido analizar ninguna página. No es un problema de tu web.',
      blocked:
        'No se ha podido analizar ninguna página: el análisis automático no ha podido acceder a ella. El motivo de cada una está más abajo.',
      unreachable: 'No se ha podido cargar ninguna página de la web.',
      unknown: 'No conocemos la causa exacta.',
      technical: 'Detalle técnico',
    },
    consumption: {
      reserved_one:
        'Mientras dura, se reserva hasta {{count}} página de tu saldo. Al terminar solo se cuentan las páginas analizadas.',
      reserved_other:
        'Mientras dura, se reservan hasta {{count}} páginas de tu saldo. Al terminar solo se cuentan las páginas analizadas.',
      used_one: 'Consumo de este análisis: {{count}} página.',
      used_other: 'Consumo de este análisis: {{count}} páginas.',
      none: 'Consumo de este análisis: ninguna página.',
      notCounted_one: 'La página que no se ha analizado no se ha contado.',
      notCounted_other: 'Las {{count}} páginas que no se han analizado no se han contado.',
    },
    actions: {
      settings: 'Revisar configuración',
      prepare: 'Nuevo análisis',
      previousResults: 'Ver los resultados de ese análisis',
      seeResults: 'Ver resultados',
    },
  },
  compare: {
    title: 'Respecto al análisis del {{date}}',
    same: 'Misma estimación',
    points_one: '{{signed}} punto',
    points_other: '{{signed}} puntos',
    resolved_one: '{{count}} problema resuelto',
    resolved_other: '{{count}} problemas resueltos',
    new_one: '{{count}} problema nuevo',
    new_other: '{{count}} problemas nuevos',
  },
  check: {
    title: 'Última comprobación de correcciones',
    titleNote: 'No es un análisis de toda la web',
    scope:
      'Una comprobación solo analiza las páginas de los elementos que se comprueban: no es un análisis de toda la web, así que no calcula la estimación ni se compara con análisis anteriores.',
    looked: 'Se han comprobado {{elements}} en {{pages}}.',
    elementsCount_one: '{{count}} elemento',
    elementsCount_other: '{{count}} elementos',
    pagesCount_one: '{{count}} página',
    pagesCount_other: '{{count}} páginas',
    pending: 'No confirmado automáticamente',
    summaryPending_one:
      'No se ha podido confirmar automáticamente {{count}} elemento. El selector ya no falla, pero hace falta revisarlo a mano.',
    summaryPending_other:
      'No se ha podido confirmar automáticamente {{count}} elementos. Sus selectores ya no fallan, pero hace falta revisarlos a mano.',
    summaryPossibleChange_one:
      'El elemento ya no falla con su selector original, pero en la página sigue habiendo otros fallos del mismo tipo. El análisis no puede asegurar que sea el mismo elemento: revísalo a mano.',
    summaryPossibleChange_other:
      '{{count}} elementos ya no fallan con su selector original, pero en la página sigue habiendo otros fallos del mismo tipo. El análisis no puede asegurar que sean los mismos: revísalos a mano.',
    summaryPersists_one: '{{count}} elemento sigue detectándose tras la comprobación.',
    summaryPersists_other: '{{count}} elementos siguen detectándose tras la comprobación.',
    summaryVerified: 'Los elementos comprobados ya no se detectan en esta comprobación.',
    summaryMixed:
      '{{verified}} sin detectar · {{persists}} siguen detectándose · {{pending}} no confirmados automáticamente.',
    nextPending: 'Revisar en el seguimiento',
    nextPersists: 'Ver el seguimiento',
    nextVerified: 'Ver el seguimiento',
    details: 'Ver el detalle de cada elemento',
    seeResults: 'Ver las páginas comprobadas',
    seeFollow: 'Ver el seguimiento',
  },
  figures: {
    pages: 'Páginas analizadas',
    failures: 'Problemas de WCAG',
    elements: 'Elementos afectados',
    review: 'Requieren revisión manual',
  },
  inspector: {
    title: 'Captura de la página',
    device: 'Dispositivo de la captura',
    devices: { escritorio: 'Escritorio', movil: 'Móvil' },
    frame: 'Captura de la página (se desplaza y se amplía)',
    alt: 'Captura de {{page}} en {{device}}',
    zoom: { label: 'Ampliar la captura', enlarge: 'Ampliar' },
    reload: 'Volver a cargar',
    loading: 'Cargando la captura…',
    loadError: 'No se ha podido cargar la captura. Los elementos no se marcan hasta que se vea.',
    retry: 'Volver a intentarlo',
    panHint: 'Arrastra la captura para moverte, o enfócala y usa las flechas del teclado.',
    notLocated: {
      'no-capture': 'No hay captura de este dispositivo, así que no se puede marcar el elemento.',
      'no-position':
        'No se ha podido situar este elemento en la captura (puede estar dentro de un marco, oculto o fuera de la parte visible). Su selector está en «Ver solución técnica».',
      outside:
        'Este elemento queda fuera de la parte de la página que se capturó. Mira su descripción en la guía.',
      'other-device':
        'Este elemento no se detectó en este dispositivo. Cambia de dispositivo para verlo marcado.',
    },
    noCapture: 'No hay captura de esta página en este dispositivo.',
    expired: 'La captura ya no está disponible: solo se guardan las de los dos últimos análisis de cada web.',
  },
  element: {
    guideTitle: 'Guía para {{name}}',
    shared: {
      title_one: 'Este elemento está compartido en {{count}} página',
      title_other: 'Este elemento está compartido en {{count}} páginas',
      here: 'Se gestiona desde esta página. Lo que indiques aquí se aplica a las {{count}} páginas.',
      there: 'Se gestiona desde {{page}}. Lo que indiques aquí también se aplica a las {{count}} páginas.',
      open: 'Abrir en {{page}}',
      identical: 'El código es idéntico en todas.',
      textChanges:
        'Misma estructura; cambian el texto o las direcciones entre páginas (por ejemplo, entre idiomas).',
      progress: {
        'sin-aplicar': 'Corrección sin aplicar en ninguna página.',
        'aplicada-en-parte': 'Corrección aplicada solo en parte de las páginas.',
        aplicada: 'Corrección aplicada en todas las páginas: falta verificarla.',
        'verificada-en-parte': 'Corrección verificada solo en parte de las páginas: no se da por resuelta.',
        verificada: 'Corrección verificada en todas las páginas.',
      },
      separately:
        'Marcar como aplicada no verifica la corrección: solo un nuevo análisis o una revisión manual la confirma.',
    },
    panel: {
      back: 'Todos los problemas',
      problem: 'Problema',
      solution: 'Solución',
      showWhere: 'Ver dónde está',
      backToSolution: 'Volver a la solución',
      captureTitle: 'Dónde está el elemento',
      element: 'Elemento afectado',
      verifyAuto: 'Después de corregirlo, un nuevo análisis lo comprobará automáticamente.',
      verifyManual:
        'Requiere revisión manual: el análisis automático no puede decidirlo y una persona tiene que comprobarlo.',
      technical: 'Ver solución técnica',
      wcag: 'Referencias WCAG',
      measured: 'Medido',
    },
    nav: {
      label: 'Elementos del problema en esta página',
      position: 'Elemento {{index}} de {{total}} en esta página',
      previous: 'Anterior',
      next: 'Siguiente',
      status: 'Elemento {{index}} de {{total}} en esta página: {{name}}.',
      sample:
        'Se muestran {{shown}} de {{total}} elementos: de los demás no se guarda dónde están ni su código.',
      analysisTotal_one: '{{count}} en todo el análisis',
      analysisTotal_other: '{{count}} en todo el análisis',
      noElements:
        'Este problema afecta a la página entera, no a un elemento que se pueda señalar. Sigue los pasos de arriba.',
    },
    sections: {
      owner: 'Quién puede hacerlo',
      check: 'Cómo comprobarlo',
    },
    where: {
      positionValue: 'A un {{vertical}} % desde la parte de arriba de la página, {{side}}',
      positionSide: 'En la página, {{side}}',
      sides: { left: 'a la izquierda', center: 'en el centro', right: 'a la derecha' },
    },
    roles: {
      desarrollo: 'Quien desarrolla o mantiene el código de la web',
      diseno: 'Quien diseña o maqueta la web',
      contenido: 'Quien edita los contenidos de la web (textos, imágenes, enlaces)',
      unknown: 'Quien mantiene la web',
      note: 'Esto depende del tipo de problema. No sabemos quién mantiene tu web ni qué permisos tienes: si no puedes hacerlo tú, copia las instrucciones para quien lo haga.',
    },
    generic: {
      check1: 'Aplica el cambio en tu web y vuelve a cargar la página.',
      check2: 'Comprueba que este elemento ya no tiene el problema descrito.',
      check3:
        'Haz un análisis nuevo de la página para confirmar que SiteNorma ya no lo detecta. Copiar o aplicar un cambio no da el problema por corregido.',
    },
    proposal: {
      adapted: 'Propuesta adaptada a este elemento',
      example: 'Ejemplo que requiere adaptación',
      currentCode: 'Código actual',
      proposedCode: 'Cambio propuesto ({{language}})',
      copy: 'Copiar código',
      copied: 'Código copiado.',
      failed: 'No se ha podido copiar. Selecciona el texto y cópialo a mano.',
      whereKnown: 'Dónde aplicarlo: {{where}}.',
      whereUnknown:
        'No sabemos en qué archivo o plantilla de tu web se aplica este cambio: búscalo o pásaselo a quien mantiene la web.',
      notAGuarantee:
        'Es una propuesta, no una corrección garantizada: hasta que un análisis nuevo lo confirme, el problema sigue abierto.',
    },
    decision: { choose: 'Elige una opción para ver la propuesta.' },
    verify: {
      title: 'Comprobar la corrección',
      text: 'Copiar el código, aplicar un cambio o cambiar el estado aquí no da el problema por corregido. Para confirmarlo hace falta una comprobación: un análisis nuevo (usa páginas de tu saldo y siempre pasa por el resumen previo) o una revisión manual.',
      action: 'Comprobar la corrección',
    },
    technical: {
      selector: 'Selector',
      location: 'Localización técnica',
      position: 'Posición',
      xpath: 'Ruta XPath',
      code: 'Código actual',
    },
    copy: {
      action: 'Copiar instrucciones para el desarrollador',
      copied: 'Instrucciones copiadas.',
      failed: 'No se han podido copiar. Selecciona el texto de la guía y cópialo a mano.',
      title: 'SiteNorma · Instrucciones para corregir un problema de accesibilidad',
      problem: 'Problema',
      what: 'Qué ocurre',
      where: 'Dónde está',
      element: 'Elemento',
      page: 'Página',
      device: 'Dispositivo',
      position: 'Posición aproximada',
      date: 'Fecha del análisis',
      evidence: 'Evidencias',
      how: 'Cómo corregirlo',
      currentCode: 'Código actual',
      check: 'Cómo comprobarlo',
      selector: 'Selector',
      note: 'Copiar estas instrucciones o aplicar el cambio no da el problema por corregido: solo un análisis nuevo de SiteNorma lo confirma. El análisis automático solo detecta una parte de las barreras de accesibilidad.',
    },
  },
  manual: {
    title: 'Comprobaciones manuales',
    intro:
      'Algunos aspectos de accesibilidad necesitan una revisión por una persona. Sigue las instrucciones y registra lo que has comprobado.',
    available:
      'Puedes empezar una revisión cuando quieras: no hace falta esperar a corregir los problemas que ha detectado el análisis automático, y un análisis automático sin detecciones no cierra una revisión pendiente.',
    notAudit:
      'Una guía te ayuda a comprobar un aspecto en una página. No es una evaluación de toda tu web, y registrar una revisión no significa que tu web cumpla la normativa.',
    readOnly: 'Tu rol solo permite consultar las revisiones.',
    progress: {
      title: 'Progreso de la revisión manual',
      summary: '{{registered}} de {{total}} criterios con alguna revisión registrada',
      text: 'En la barra, {{registered}} de {{total}} criterios tienen alguna revisión registrada.',
      started_one: '{{count}} criterio más tiene un borrador sin registrar.',
      started_other: '{{count}} criterios más tienen un borrador sin registrar.',
      needNew_one: '{{count}} revisión necesita una nueva revisión porque la página ha cambiado.',
      needNew_other: '{{count}} revisiones necesitan una nueva revisión porque la página ha cambiado.',
      answers: 'Respuestas vigentes',
      note: 'Este progreso es solo el de las revisiones manuales: va aparte del análisis automático y del seguimiento del trabajo. Una revisión registrada confirma que se ha hecho, no que se haya superado, y revisar un criterio en una página no dice nada del resto de tu web.',
    },
    state: {
      'no-iniciada': 'Revisión manual no iniciada',
      pendiente: 'Pendiente de revisión',
      registrada: 'Revisión manual con respuesta',
    },
    answer: {
      'sin-problemas': 'No he encontrado problemas',
      problema: 'He encontrado un problema',
      'no-comprobado': 'No he podido comprobarlo',
      'no-aplica': 'No aplica',
    },
    condition: {
      teclado: 'Solo con el teclado',
      'lector-de-pantalla': 'Con un lector de pantalla',
      zoom: 'Con zoom o con el texto ampliado',
      'espaciado-de-texto': 'Con el espaciado del texto cambiado',
      movil: 'En un móvil o con la pantalla estrecha',
      'colores-forzados': 'Con colores forzados o alto contraste',
      'escala-de-grises': 'En escala de grises',
      'sin-estilos': 'Sin estilos (sin CSS)',
      'sin-sonido': 'Sin sonido',
      'reducir-movimiento': 'Con «reducir movimiento» activado',
      voz: 'Con control por voz',
    },
    answerHint: {
      'sin-problemas':
        'Has seguido la guía y todo lo que debería ocurrir ocurre. Se ha comprobado lo que has revisado, no el resto de la web.',
      problema: 'Algo de lo que debería ocurrir no ocurre. Describe qué has visto: se creará un problema.',
      'no-comprobado':
        'No has podido hacer la comprobación (te faltaba una herramienta, una página no cargaba…). Sigue sin estar comprobado, no es una respuesta favorable.',
      'no-aplica':
        'La página no tiene lo que la guía comprueba (por ejemplo, no hay vídeos). Hay que justificarlo.',
    },
    help: {
      guiada: 'Revisión guiada',
      especializada: 'Puede requerir ayuda especializada',
      none: 'Sin guía disponible',
    },
    noGuide:
      'No hay una guía disponible para este aspecto, así que no se puede comprobar siguiendo pasos desde aquí. Sigue pendiente de revisión.',
    needsNew: 'Necesita una nueva revisión',
    needsNewHint:
      'La página ha cambiado desde que se revisó. Se mantiene la valoración anterior hasta que se repita la revisión.',
    row: {
      automatic: 'Análisis automático',
      manual: 'Revisión manual',
      pages_one: 'en {{count}} página',
      pages_other: 'en {{count}} páginas',
      reviews_one: '{{count}} revisión registrada',
      reviews_other: '{{count}} revisiones registradas',
      drafts_one: '{{count}} borrador',
      drafts_other: '{{count}} borradores',
      by: '{{name}}, {{date}}',
      someone: 'una persona de tu organización',
    },
    actions: {
      start: 'Empezar revisión',
      resume: 'Continuar revisión',
      view: 'Ver las revisiones y repetir',
      repeat: 'Repetir la revisión',
      guide: 'Ver la guía',
      back: 'Volver a los resultados',
    },
    page: {
      title: 'Comprobación manual: {{id}} {{title}}',
      level: 'Nivel {{level}}',
      principle: '{{name}}',
      siteScope:
        'Esta comprobación compara varias páginas, así que se registra para toda la web y no para una página.',
      noPages:
        'Todavía no hay páginas analizadas, y esta comprobación se hace sobre una página. Haz un análisis y vuelve.',
      loadFailed: 'No se ha podido cargar la guía. Inténtalo de nuevo.',
    },
    guide: {
      what: 'Qué vas a comprobar',
      how: 'Cómo hacerlo',
      expected: 'Qué debería ocurrir',
      record: 'Cómo registrar el resultado',
      recordAnswers: 'Elige la respuesta que corresponda:',
      specialist: 'Por qué puede hacer falta ayuda especializada',
      version: 'Versión de la guía: {{version}}.',
    },
    form: {
      title: 'Tu revisión',
      identify: 'Qué estás revisando',
      page: 'Página',
      pageHelp: 'La página que has revisado, de las que ha analizado SiteNorma.',
      pagePlaceholder: 'Elige una página',
      whole: 'Toda la web',
      element: 'Elemento',
      elementHelp: 'Opcional: la parte de la página que has revisado, por ejemplo «Menú principal».',
      device: 'Dispositivo',
      devices: { ambos: 'Escritorio y móvil', escritorio: 'Escritorio', movil: 'Móvil' },
      conditions: 'Condiciones de la comprobación',
      conditionsHelp: 'Marca lo que has usado para comprobarlo.',
      conditionNotes: 'Otras condiciones',
      conditionNotesHelp: 'Navegador y versión, lector de pantalla, tamaño de la ventana…',
      answer: 'Resultado de la comprobación',
      answerHelp: 'Si no eliges ninguna respuesta, la revisión sigue pendiente.',
      description: 'Qué has encontrado',
      descriptionHelp: 'Obligatorio si has encontrado un problema: qué falla, dónde y cómo se nota.',
      reason: 'Por qué no has podido comprobarlo',
      reasonHelp: 'Opcional, pero ayuda a quien lo retome.',
      justification: 'Por qué no aplica',
      justificationHelp:
        'Obligatorio: explica por qué esta página no tiene lo que se comprueba (al menos 20 caracteres).',
      severity: 'Cuánto dificulta usar la web',
      severities: {
        grave: 'Impide completar una tarea',
        moderada: 'Dificulta, pero se puede completar',
        leve: 'Molesta, pero no impide hacerlo',
      },
      severityHelp: 'Da la prioridad del problema, igual que los problemas del análisis automático.',
      evidence: 'Evidencias',
      evidenceHelp:
        'Lo que viste, las herramientas y versiones que usaste, un enlace a una captura o a una grabación.',
      save: 'Guardar borrador',
      saving: 'Guardando…',
      register: 'Registrar revisión',
      registering: 'Registrando…',
      discard: 'Descartar borrador',
      discardConfirm: 'Descartar el borrador',
      discardBody: 'Se borra lo que has escrito en este borrador. Las revisiones registradas no se tocan.',
      cancel: 'Cancelar',
    },
    saved: {
      draft: 'Borrador guardado. La revisión sigue pendiente: aún no hay una respuesta registrada.',
      registered:
        'Revisión manual registrada. Esto confirma que se ha guardado; no significa que la comprobación se haya superado.',
      discarded: 'Borrador descartado.',
    },
    errors: {
      respuesta: 'Elige una respuesta para registrar la revisión, o guarda un borrador.',
      pagina: 'Elige la página que has revisado.',
      descripcion: 'Describe el problema que has encontrado (al menos 10 caracteres).',
      gravedad: 'Indica cuánto dificulta usar la web.',
      justificacion: 'Explica por qué no aplica (al menos 20 caracteres).',
      registrada: 'Esta revisión ya está registrada y no se puede cambiar. Repítela para añadir una nueva.',
      permiso: 'Tu rol no permite registrar revisiones.',
      'sin-guia': 'No hay guía para este aspecto.',
      datos: 'Revisa los datos del formulario.',
      generic: 'No se ha podido guardar. Inténtalo de nuevo.',
    },
    drafts: {
      title: 'Tus borradores en curso',
      intro: 'Retómalos donde los dejaste.',
      open: 'Continuar este borrador',
      updated: 'Guardado el {{date}}',
      start: 'Empezar una revisión nueva',
    },
    history: {
      title: 'Revisiones anteriores',
      intro:
        'Se conservan todas, con las instrucciones que se siguieron y sus evidencias: una revisión nueva se suma a las anteriores y no las sustituye.',
      empty: 'Todavía no hay ninguna revisión registrada de este aspecto.',
      current: 'Valoración vigente',
      earlier: 'Anterior',
      by: 'Registrada por {{name}}, {{date}}',
      page: 'Página',
      element: 'Elemento',
      device: 'Dispositivo',
      conditions: 'Condiciones',
      none: 'Sin indicar',
      description: 'Qué se encontró',
      reason: 'Por qué no se pudo comprobar',
      justification: 'Por qué no aplica',
      evidence: 'Evidencias',
      severity: 'Cuánto dificulta',
      instructions: 'Instrucciones que se siguieron (versión {{version}})',
      afterFix: 'Hecha para comprobar una corrección',
      repeats: 'Repite una revisión anterior',
    },
    found: {
      origin: 'Detectado en revisión manual',
      from: 'Revisión manual del criterio {{id}}',
      by: 'Revisado por {{name}}, {{date}}',
      element: 'Elemento: {{element}}',
      device: 'Dispositivo: {{device}}',
      conditions: 'Condiciones: {{list}}',
      evidence: 'Evidencias: {{text}}',
      open: 'Ver la guía y repetir la revisión',
      note: 'Este problema viene de una revisión manual: se cierra con una revisión posterior que no encuentre el problema, no con un análisis automático.',
    },
    follow: {
      title: 'Comprobación manual guiada',
      hint: 'Cuando el análisis automático no puede decidir, una persona puede repetir la comprobación siguiendo la guía. Una revisión favorable que cubra todos los dispositivos donde se detectó permite archivar el trabajo.',
      repeat: 'Repetir la guía «{{title}}»',
      repeatId: 'Repetir la guía del criterio {{id}}',
    },
    prepare: {
      title: 'Comprobaciones que piden a una persona',
      intro:
        'Para estos elementos el análisis automático no puede decidir por sí solo. Puedes repetir la comprobación con la guía; el análisis no la cierra.',
      repeat: 'Repetir la guía {{id}} para {{element}}',
    },
  },
  follow: {
    panel: {
      intro:
        'El estado indica el progreso de la corrección. Para confirmar que el problema está resuelto, es necesario verificarlo.',
      kinds: {
        'sin-comprobar': 'Sin verificar',
        pendiente: 'Verificación pendiente',
        verificado: 'Verificado',
        persiste: 'Sigue detectándose el problema',
        descartada: 'Detección descartada',
      },
      sources: { automatica: 'Análisis automático', manual: 'Comprobación manual' },
      on: '{{source}} · {{date}}',
      hints: {
        pendiente: 'Vuelve a analizar la página para comprobarlo.',
        persiste: 'Revisa la corrección y vuelve a analizar la página.',
        descartada: 'Esta detección no cuenta como problema.',
      },
      manual: 'El análisis automático no puede decidir este caso. Requiere comprobación manual.',
      recheck: 'Volver a analizar',
      check: 'Comprobar la corrección',
      advanced: 'Opciones avanzadas',
      advancedHint: 'Validación, descarte, comprobación manual, historial y cambios en varios elementos',
      bulk: {
        title: 'Aplicar estado a los {{count}} elementos',
        hint: 'Selecciona el estado que quieres aplicar.',
        choose: 'Elige un estado',
        apply: 'Aplicar',
        confirmTitle: '¿Aplicar el estado a {{count}} elementos?',
        confirmBody:
          'Cambiará el estado del trabajo de {{count}} elementos. No se modifican los resultados de verificación y cada elemento conserva su historial.',
        confirm: 'Aplicar estado',
        cancel: 'Cancelar',
        done: 'Estado aplicado a {{count}} elementos.',
        label: 'Estado a aplicar',
      },
    },
    quick: {
      work: 'Estado del trabajo',
      verification: 'Verificación',
      more: 'Más opciones de seguimiento',
    },
    title: 'Estado del problema',
    save: 'Guardar estado',
    saving: 'Guardando…',
    notice: 'Cambiar el estado en SiteNorma no modifica tu web. Aplica la corrección antes de comprobarla.',
    readOnly: 'Tu rol solo permite consultar el estado.',
    saved: 'Estado guardado.',
    savedMany_one:
      'Estado guardado en {{count}} elemento, que conserva su propio historial. No se ha iniciado ningún análisis ni se ha usado ninguna página.',
    savedMany_other:
      'Estado guardado en {{count}} elementos, cada uno con su propio historial. No se ha iniciado ningún análisis ni se ha usado ninguna página.',
    errors: {
      justificacion: 'Para descartar una detección explica por qué: al menos 20 caracteres.',
      evidencia: 'Para descartar una detección indica la evidencia que lo respalda: al menos 10 caracteres.',
      permiso: 'Tu rol no permite cambiar el estado.',
      'permiso-descartar':
        'Solo el propietario y las personas administradoras pueden descartar una detección.',
      vacio: 'Elige qué quieres cambiar antes de guardar.',
      demasiados: 'Son demasiados elementos de una vez. Hazlo problema por problema.',
      generic: 'No se ha podido guardar el estado. Inténtalo de nuevo.',
    },
    by: '{{name}}, {{date}}',
    someone: 'una persona de tu organización',
    system: 'un análisis',
    noteLabel: 'Nota',
    noteHint: 'Opcional. Queda en el historial con tu nombre y la fecha.',
    work: {
      title: 'Seguimiento del trabajo',
      description: 'Lo que hace tu equipo. No dice si el problema está resuelto.',
      statuses: {
        pendiente: 'Pendiente de corregir',
        'en-curso': 'En curso',
        aplicada: 'Corrección aplicada',
        aplazada: 'Aplazada',
        archivada: 'Trabajo archivado',
      },
      hints: {
        pendiente: 'Nadie ha empezado a corregirlo.',
        'en-curso': 'Alguien del equipo está trabajando en ello.',
        aplicada:
          'Ya has cambiado la web. Sigue pendiente de verificar: solo una comprobación puede confirmarlo.',
        aplazada: 'Se corregirá más adelante. El problema sigue en los resultados y en la puntuación.',
      },
      reopens: 'Elegir un estado reabre el trabajo archivado.',
    },
    validation: {
      title: 'Validación de la detección',
      description: 'Si la detección es un problema real. No dice si está corregido.',
      none: 'Detección automática, sin validación manual',
      statuses: {
        pendiente: 'Pendiente de validar',
        confirmada: 'Detección confirmada',
        descartada: 'Detección descartada con justificación',
      },
      hints: {
        pendiente: 'Hay que revisarlo a mano antes de decidir si es un problema.',
        confirmada: 'Una persona ha comprobado que es un problema real. No significa que esté corregido.',
        descartada:
          'No es un problema real en esta web. Sale de los recuentos y de la puntuación, y se lista aparte con tu justificación.',
        revert: 'Quita la decisión anterior y vuelve a validar la detección.',
      },
      keep: 'Sin cambios',
      adminOnly:
        'Descartar una detección cambia los recuentos y la puntuación: solo pueden hacerlo el propietario y las personas administradoras.',
      justification: 'Justificación',
      justificationHint: 'Por qué no es un problema en esta web. Al menos 20 caracteres.',
      evidence: 'Evidencia',
      evidenceHint:
        'Qué has comprobado: una prueba, una captura, un enlace o un resultado. Al menos 10 caracteres.',
      discardNote:
        'Se conservan la detección original y su historial. El elemento sale de los recuentos y de la puntuación, y se lista aparte con tu justificación, tu nombre y la fecha. Puedes retirar el descarte cuando quieras.',
      decidedBy: 'Decidido por {{name}}, {{date}}.',
      justificationLine: 'Justificación: {{text}}',
      evidenceLine: 'Evidencia: {{text}}',
    },
    check: {
      title: 'Resultado de la última comprobación',
      description: 'Lo que encontró un análisis posterior o una revisión manual.',
      none: 'Sin verificar',
      noneHint: 'Ningún análisis ni revisión ha verificado este elemento desde que se detectó.',
      results: {
        'sigue-detectandose': 'Sigue detectándose',
        'no-detectado': 'No detectado en la última comprobación',
        'no-comprobable': 'No confirmado automáticamente',
        'requiere-revision': 'Requiere revisión manual',
      },
      sources: { automatica: 'Análisis automático', manual: 'Revisión manual' },
      on: '{{source}} del {{date}}',
      devices: 'Dispositivos: {{list}}.',
      stillPending:
        'La corrección sigue pendiente de verificar: un resultado que no es «No detectado» no la da por comprobada.',
      reasons: {
        detectado: 'El análisis volvió a encontrar este elemento.',
        'detectado-en-revision':
          'El análisis lo encontró, pero no puede decidir si es un fallo: hay que revisarlo a mano.',
        comprobado:
          'Un análisis comparable revisó la página y ya no lo detectó. Esto no certifica que la web cumpla la normativa.',
        'revision-favorable': 'Una persona lo revisó a mano y se cumple.',
        'revision-desfavorable': 'Una persona lo revisó a mano y sigue sin cumplirse.',
        'pagina-fuera': 'La página no estaba en ese análisis, así que no se ha podido confirmar.',
        'pagina-no-analizada':
          'La web no dejó analizar la página (bloqueada, limitada o con error): no se sabe si se corrigió.',
        dispositivo:
          'El análisis no cubrió todos los dispositivos donde se detectó (escritorio y móvil): no es comparable.',
        versiones:
          'Ese análisis usó otra versión del motor o de las reglas, así que no es comparable con el que detectó el problema. Vuelve a comprobarlo.',
        'regla-no-aplicada':
          'La prueba no encontró ningún elemento de este tipo en la página: puede que lo hayas eliminado o cambiado de sitio. Compruébalo a mano.',
        muestra:
          'La prueba solo lista una parte de los elementos de la página y este no está entre ellos: no se puede asegurar que esté corregido.',
        'posible-cambio':
          'Este elemento ya no falla con su selector original, pero en la página sigue habiendo otros fallos del mismo tipo. Podría ser el mismo con otra dirección en el código: el análisis no lo confirma solo. Revísalo a mano.',
        'ventana-emergente':
          'Está en una ventana emergente o un aviso que puede no aparecer al analizar. Revísalo a mano.',
        'sin-registro': 'Esta prueba no registra los elementos que cumplen: hay que revisarlo a mano.',
        incierta: 'Es un punto que las pruebas automáticas no pueden decidir: hay que revisarlo a mano.',
      },
    },
    verify: {
      action: 'Comprobar la corrección',
      hint: 'Abre el resumen previo del análisis: ahí ves qué páginas se revisarán y cuántas usará. No empieza hasta que pulses el botón de analizar.',
      many_one: 'Comprobar la corrección aplicada',
      many_other: 'Comprobar las {{count}} correcciones aplicadas',
    },
    review: {
      title: 'Registrar una revisión manual',
      hint: 'Úsala cuando el análisis no pueda decidirlo (una ventana emergente, un elemento que ha cambiado de sitio, un punto por revisar) o prefieras comprobarlo tú. Sigue los pasos de «Cómo comprobarlo».',
      outcome: 'Resultado de la revisión',
      favorable: 'Se cumple',
      favorableHint: 'Ya no es un problema en los dispositivos que has revisado.',
      desfavorable: 'Sigue sin cumplirse',
      desfavorableHint: 'El problema sigue ahí.',
      devices: 'Dispositivos que has revisado',
      devicesHint: 'Una revisión favorable tiene que cubrir todos los dispositivos donde se detectó.',
      note: 'Qué has hecho y qué has visto',
      noteHint: 'Al menos 10 caracteres. Queda en el historial.',
      save: 'Registrar revisión',
      saved: 'Revisión registrada.',
      errors: {
        ambito: 'Una revisión favorable tiene que cubrir todos los dispositivos donde se detectó.',
        archivada: 'Este trabajo está archivado: reábrelo antes de registrar otra revisión.',
        permiso: 'Tu rol no permite registrar revisiones.',
        generic: 'No se ha podido registrar la revisión. Inténtalo de nuevo.',
      },
    },
    archive: {
      title: 'Archivar trabajo de corrección',
      evidence: 'Evidencia que lo justifica',
      evidenceAuto: 'Un análisis comparable del {{date}} revisó la página y ya no detectó este elemento.',
      evidenceManual: 'Una revisión manual favorable del {{date}}.',
      noteLabel: 'Nota del archivo',
      noteHint: 'Opcional.',
      action: 'Archivar trabajo de corrección',
      archiving: 'Archivando…',
      done: 'Trabajo archivado.',
      notCertification:
        'Archivar no certifica que la web cumpla la normativa: cierra el trabajo sobre este elemento con la evidencia de una comprobación. Si una comprobación comparable vuelve a detectarlo, el trabajo se reabre como pendiente.',
      archivedBy: 'Trabajo archivado el {{date}} por {{name}}.',
      why: {
        'sin-comprobacion':
          'Se podrá archivar cuando un análisis comparable ya no detecte el problema, o cuando se registre una revisión manual favorable.',
        'no-favorable':
          'Todavía no se puede archivar: la última comprobación no es favorable. Se podrá archivar con una comprobación que no lo detecte o con una revisión manual favorable.',
        'anterior-a-la-correccion':
          'La última comprobación favorable es anterior a la corrección que marcaste como aplicada. Vuelve a comprobarla.',
        'ya-archivada': 'El trabajo ya está archivado.',
      },
      errors: {
        'sin-evidencia': 'Ya no hay una comprobación que justifique archivarlo. Revisa el resultado.',
        permiso: 'Tu rol no permite archivar.',
        generic: 'No se ha podido archivar. Inténtalo de nuevo.',
      },
    },
    history: {
      title: 'Historial',
      loading: 'Cargando el historial…',
      empty: 'Todavía no hay nada en el historial.',
      error: 'No se ha podido cargar el historial.',
      note: 'Nota: {{text}}',
      created: 'Se empezó a seguir este elemento.',
      createdMigrated:
        'Se conserva una decisión anterior sobre el grupo al que pertenecía este elemento ({{from}}).',
      work: 'Seguimiento del trabajo: de «{{from}}» a «{{to}}».',
      validation: 'Validación de la detección: de «{{from}}» a «{{to}}».',
      lifted: 'Se retiró un descarte que decía: «{{justification}}» (evidencia: «{{evidence}}»).',
      check: 'Comprobación automática: {{result}}. {{reason}}',
      review: 'Revisión manual ({{outcome}}) en {{devices}}: {{text}}',
      guided: 'Revisión guiada del criterio {{criterion}}: {{outcome}}. Dispositivos: {{devices}}. {{text}}',
      archive: 'Trabajo de corrección archivado.',
      reopenManual: 'Trabajo archivado reabierto al elegir un estado.',
      reopenAuto: 'Trabajo reabierto como pendiente: una comprobación volvió a detectarlo.',
      none: 'sin decisión',
      actor: '{{name}}, {{date}}',
    },
    summary: {
      figures: {
        tracked: 'Elementos seguidos',
        applied: 'Corrección aplicada',
        verified: 'Verificados por comprobación',
      },
      title: 'Seguimiento del trabajo y decisiones',
      intro:
        'Tres cifras distintas: cuántos elementos sigue tu equipo, en cuántos habéis declarado la corrección y en cuántos una comprobación ya no los detecta. «Corrección aplicada» no los verifica: hace falta comprobarlos.',
      none: 'Tu equipo todavía no ha registrado nada sobre los elementos de esta web.',
      tracked_one: '{{count}} elemento en seguimiento',
      tracked_other: '{{count}} elementos en seguimiento',
      discarded_one:
        '{{count}} detección descartada con justificación: no cuenta en los recuentos ni en la puntuación.',
      discarded_other:
        '{{count}} detecciones descartadas con justificación: no cuentan en los recuentos ni en la puntuación.',
      open: 'Abrir el seguimiento',
    },
    tab: {
      name: 'Seguimiento',
      title: 'Seguimiento de las correcciones',
      intro:
        'El estado del trabajo (por ejemplo «Corrección aplicada»), el resultado de la comprobación y los descartes. Declarar la corrección no la verifica: hay que comprobarla.',
      viewProblems: 'Ver problemas',
      loadFailed: 'No se ha podido cargar el seguimiento.',
      empty:
        'Todavía no hay correcciones registradas. Empieza por los problemas detectados y registra el estado de un elemento.',
      filters: 'Filtros',
      work: 'Seguimiento del trabajo',
      check: 'Resultado de la comprobación',
      all: 'Todos',
      shown_one: 'Se muestra {{shown}} de {{total}} elemento.',
      shown_other: 'Se muestran {{shown}} de {{total}} elementos.',
      none: 'Ningún elemento coincide con los filtros.',
      element: 'Elemento',
      problem: 'Problema',
      page: 'Página',
      states: 'Estado',
      open: 'Ver el elemento',
      openPage: 'Ver la página',
      noCapture: 'Ya no está en el último análisis.',
      checkAll: 'Comprobar las correcciones aplicadas',
      checkAllHint_one:
        'La corrección marcada como aplicada se comprobará desde el resumen previo del análisis.',
      checkAllHint_other:
        'Las {{count}} correcciones marcadas como aplicadas se comprobarán desde el resumen previo del análisis.',
      checkTooMany:
        'Hay correcciones aplicadas en más de {{max}} páginas: se comprobarán por partes. Abre cada una desde su ficha.',
      discards: 'Detecciones descartadas con justificación',
      discardsIntro:
        'Salen de los recuentos y de la puntuación. La detección original y su historial se conservan.',
      discardedBy: 'Descartada por {{name}}, {{date}}.',
      lift: 'Para retirar un descarte, abre el elemento.',
      manage: 'Gestionar el estado',
      showArchived: 'Mostrar el trabajo archivado',
    },
    problem: {
      title: 'Estado del problema',
      counts_one: '{{count}} elemento con seguimiento de {{total}}',
      counts_other: '{{count}} elementos con seguimiento de {{total}}',
      bulkTitle: 'Aplicar el mismo estado a todos los elementos',
      bulkHint:
        'Se guarda por separado en cada elemento, con su propio historial. Úsalo cuando el estado sea igual para todos.',
      bulkApplies_one: 'Se aplicará a {{count}} elemento de este problema.',
      bulkApplies_other: 'Se aplicará a los {{count}} elementos de este problema.',
      discardedElements_one: '{{count}} elemento descartado con justificación',
      discardedElements_other: '{{count}} elementos descartados con justificación',
      allDiscarded:
        'Todos los elementos de este problema están descartados con justificación: no cuenta en los recuentos ni en la puntuación.',
    },
    discardedList: {
      title: 'Problemas descartados con justificación',
      intro:
        'Todos sus elementos están descartados, así que no cuentan en los totales ni en la puntuación. Abre uno para ver la justificación o retirar el descarte.',
    },
  },
  site: {
    created: 'Web añadida. El análisis todavía no se ha iniciado.',
    back: 'Tus webs',
    address: 'Dirección',
    profile: 'Perfil normativo',
    tabs: { pages: 'Páginas', follow: 'Seguimiento' },
    details: 'Detalles de la web',
    analysisStandard: 'Estándar utilizado en el análisis',
    harmonised: 'Referencia europea armonizada actual',
    standardsNote:
      'La referencia armonizada es la versión que cita hoy el Diario Oficial de la Unión Europea (Decisión (UE) 2021/1339). El estándar del análisis depende del perfil normativo de la web.',
    verificationLink: 'ir a la verificación de propiedad',
    verifyAction: 'Verificar la propiedad',
    notFound: 'Esta web no existe o no pertenece a tu organización.',
    verification: {
      steps: {
        choose: 'Elige cómo',
        publish: 'Publica el código',
        check: 'Compruébalo',
        done: 'hecho',
      },
      title: 'Verificación de propiedad',
      intro: 'Verificar la web demuestra que es tuya.',
      without: 'Sin verificar: análisis de una página y análisis rápido (3 páginas).',
      with: 'Con la propiedad verificada: análisis completo (hasta 50 páginas), que no depende del robots.txt.',
      verified: 'Propiedad verificada el {{date}} ({{method}}).',
      readOnly: 'Pide a alguien con rol de editor o superior que la verifique.',
      method: 'Cómo quieres verificarla',
      methods: { meta: 'Etiqueta meta', dns: 'Registro DNS', fichero: 'Fichero' },
      methodHints: {
        meta: 'La más rápida, si puedes editar el código de la página de inicio.',
        dns: 'Para quien gestiona el dominio; sirve aunque un cortafuegos bloquee la web. Puede tardar unas horas.',
        fichero: 'Si puedes subir ficheros al servidor de la web.',
      },
      metaSteps:
        'Pega esta etiqueta dentro de <head> en {{url}}, publica el cambio y pulsa «Comprobar ahora»:',
      dnsSteps:
        'En el DNS de tu dominio, crea un registro TXT con el nombre {{host}} y este valor, y pulsa «Comprobar ahora»:',
      dnsNote: 'Los cambios de DNS pueden tardar unas horas en verse.',
      fileSteps:
        'Crea un fichero de texto accesible en {{url}} con este contenido y pulsa «Comprobar ahora»:',
      tag: 'Etiqueta',
      record: 'Valor del registro TXT',
      fileContent: 'Contenido del fichero',
      copy: 'Copiar',
      copied: 'Copiado',
      check: 'Comprobar ahora',
      checking: 'Comprobando la verificación…',
      checkingHint:
        'Estamos comprobando el código en tu web. Puedes salir de esta pantalla; el resultado aparecerá aquí.',
      checkingWait:
        'La comprobación sigue en curso. Si la web responde despacio, puede tardar unos segundos más.',
      checkingSlow:
        'Llevamos más de 15 segundos. Si la web no responde, la comprobación fallará y podrás probar otro método.',
      done: 'Hecho: hemos verificado la propiedad de la web.',
      errors: {
        'meta-missing':
          'No encontramos la etiqueta en {{url}}. Comprueba que esté dentro de <head> y que la página publicada ya la tenga.',
        'file-missing': 'El fichero existe, pero no contiene el código. Revisa su contenido.',
        'dns-missing':
          'Todavía no vemos el registro TXT. Los cambios de DNS pueden tardar unas horas: vuelve a probar más tarde.',
        http: 'No hemos podido completar la verificación porque la web ha devuelto un error HTTP {{status}}. Comprueba que la dirección sea correcta y que la página esté disponible. También puedes probar otro método de verificación, como el registro DNS.',
        unreachable:
          'No hemos podido completar la verificación porque no hemos podido conectar con la web. Comprueba que la dirección sea correcta y que la web esté disponible. También puedes probar otro método de verificación, como el registro DNS.',
        timeout: 'La comprobación no ha terminado. Vuelve a intentarlo dentro de un momento.',
        limite: 'Has hecho muchas comprobaciones en poco tiempo. Espera un rato y vuelve a probar.',
      },
    },
    settings: {
      title: 'Ajustes',
      scope:
        'Estos ajustes solo afectan a esta web. Tus datos personales y tu contraseña están en <profile>Mi perfil</profile> y <security>Seguridad</security>.',
      profileUnset:
        'Todavía no has elegido un perfil normativo. Elígelo aquí o al preparar un análisis. Hasta entonces, el análisis usa WCAG 2.2 nivel AA como referencia técnica.',
      name: 'Nombre',
      save: 'Guardar cambios',
      saved: 'Cambios guardados.',
      profileNote:
        'El perfil solo indica qué normativa se toma como referencia al analizar. Elegirlo no certifica ni acredita que tu web cumpla la ley, ni decide si te afecta: eso depende de tu actividad.', // claims-ok
      cardImage: {
        title: 'Imagen de vista previa',
        intro:
          'Actualiza la captura de la página principal y el icono que aparecen en la tarjeta de esta web, en «Tus webs».\n\nEsta acción no inicia un análisis ni consume páginas de tu plan. La imagen también puede actualizarse cuando realices un nuevo análisis de la página principal.',
        action: 'Actualizar vista previa',
        working: 'Actualizando…',
        done: 'Se está capturando la nueva imagen. En unos segundos se verá en «Tus webs».',
        errors: {
          permiso: 'Tu rol no permite actualizar la imagen de esta web.',
          limite: 'Has pedido actualizar la imagen demasiadas veces. Espera un rato e inténtalo de nuevo.',
          generic: 'No hemos podido actualizar la imagen. Inténtalo de nuevo.',
        },
      },
      errors: {
        permiso: 'Tu rol no permite cambiar los ajustes de esta web. No se ha guardado nada.',
        gone: 'Esta web ya no existe. No se ha guardado nada.',
        generic: 'No hemos podido guardar los cambios. Inténtalo de nuevo.',
      },
    },
    remove: {
      title: 'Eliminar la web',
      intro: 'Se borrarán la web y todos sus datos. No se puede deshacer.',
      dataTitle: 'Se eliminará:',
      data: {
        analyses: 'Los análisis y sus resultados.',
        follow: 'El seguimiento de las correcciones, con su historial.',
        reviews: 'Las revisiones manuales registradas.',
        ownership: 'La verificación de propiedad y la vinculación con WordPress, si la hay.',
      },
      typeName: 'Escribe «{{name}}» para confirmar',
      button: 'Eliminar la web',
      confirmTitle: '¿Eliminar {{name}}?',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
    },
  },
  invitation: {
    title: 'Invitación a una organización',
    details: '{{inviter}} te invita a {{organization}} con el rol de {{role}}.',
    accept: 'Aceptar la invitación',
    acceptedTitle: 'Invitación aceptada',
    accepted: 'Ya formas parte de la organización.',
    continue: 'Ir al panel',
    loginFirst: 'Para aceptarla, entra o crea una cuenta con el email al que te llegó la invitación.',
    login: 'Entrar',
    signup: 'Crear una cuenta',
    invalid:
      'La invitación no es válida, ha caducado o es para otro email. Entra con la cuenta a la que llegó o pide que te envíen otra.',
  },
};

export type Messages = typeof es;

/** Languages that only translate part of the app (the way in and the first steps): the rest falls back. */
type DeepPartial<T> = { [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K] };
export type PartialMessages = DeepPartial<Messages>;
